<template>
  <v-navigation-drawer
    id="drawer-chat-left"
    v-model="drawer"
    app
    clipped
    width="400"
    permanent
  >
    <v-navigation-drawer
      id="drawer-chat-search"
      v-model="drawer"
      absolute
      width="70"
      style="background: #526478"
      permanent
    >
      <div
        class="drawer-item comment"
        :class="{ active: couter == 3 }"
        @click="getCovSearch(3, 'comment')"
      >
        <div class="item-image">
          <svg
            width="50"
            height="38"
            viewBox="0 0 50 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M33.5602 3H16.4398C15.9202 3 15.4999 3.42032 15.4999 3.93984V16.4602C15.4999 16.8204 15.7203 17.0498 16.0601 17.21C16.5 17.2 16.2999 17.21 16.4398 17.21C16.6601 17.21 16.4398 17.21 17.0601 17.21H21.5805H33.5805C34.1008 17.21 34.5203 16.7195 34.5203 16.2V3.93981C34.5 3.42027 34.0797 3 33.5602 3ZM29.7398 13.0796H20.2602C19.7399 13.0796 19.3203 12.6593 19.3203 12.1398C19.3203 11.6194 19.7407 11.1999 20.2602 11.1999H29.7602C30.2805 11.1999 30.7 11.6202 30.7 12.1398C30.7 12.6601 30.2601 13.0796 29.7398 13.0796ZM29.7398 8.9398H20.2602C19.7399 8.9398 19.3203 8.51948 19.3203 7.99996C19.3203 7.47964 19.7407 7.06012 20.2602 7.06012H29.7602C30.2805 7.06012 30.7 7.48044 30.7 7.99996C30.7 8.52028 30.2601 8.9398 29.7398 8.9398Z"
              fill="#C2CFE0"
            />
            <path
              d="M0.882812 35V26.4688H3.80664C4.77148 26.4688 5.50586 26.6621 6.00977 27.0488C6.51367 27.4355 6.76562 28.0117 6.76562 28.7773C6.76562 29.168 6.66016 29.5195 6.44922 29.832C6.23828 30.1445 5.92969 30.3867 5.52344 30.5586C5.98438 30.6836 6.33984 30.9199 6.58984 31.2676C6.84375 31.6113 6.9707 32.0254 6.9707 32.5098C6.9707 33.3105 6.71289 33.9258 6.19727 34.3555C5.68555 34.7852 4.95117 35 3.99414 35H0.882812ZM2.36523 31.1504V33.8164H4.01172C4.47656 33.8164 4.83984 33.7012 5.10156 33.4707C5.36328 33.2402 5.49414 32.9199 5.49414 32.5098C5.49414 31.623 5.04102 31.1699 4.13477 31.1504H2.36523ZM2.36523 30.0605H3.81836C4.2793 30.0605 4.63867 29.957 4.89648 29.75C5.1582 29.5391 5.28906 29.2422 5.28906 28.8594C5.28906 28.4375 5.16797 28.1328 4.92578 27.9453C4.6875 27.7578 4.31445 27.6641 3.80664 27.6641H2.36523V30.0605ZM9.84766 35H8.42383V28.6602H9.84766V35ZM9.90625 27.8164H8.72266L7.14062 26.041H8.76367L9.90625 27.8164ZM12.7891 28.6602L12.8301 29.3926C13.2988 28.8262 13.9141 28.543 14.6758 28.543C15.9961 28.543 16.668 29.2988 16.6914 30.8105V35H15.2676V30.8926C15.2676 30.4902 15.1797 30.1934 15.0039 30.002C14.832 29.8066 14.5488 29.709 14.1543 29.709C13.5801 29.709 13.1523 29.9688 12.8711 30.4883V35H11.4473V28.6602H12.7891ZM19.5508 29.3516C20.0156 28.8125 20.6035 28.543 21.3145 28.543C22.666 28.543 23.3516 29.3145 23.3711 30.8574V35H21.9473V30.9102C21.9473 30.4727 21.8516 30.1641 21.6602 29.9844C21.4727 29.8008 21.1953 29.709 20.8281 29.709C20.2578 29.709 19.832 29.9629 19.5508 30.4707V35H18.127V26H19.5508V29.3516ZM29.3184 35H27.8945V26H29.3184V35ZM34.7148 34.3789C34.2969 34.8711 33.7031 35.1172 32.9336 35.1172C32.2461 35.1172 31.7246 34.916 31.3691 34.5137C31.0176 34.1113 30.8418 33.5293 30.8418 32.7676V28.6602H32.2656V32.75C32.2656 33.5547 32.5996 33.957 33.2676 33.957C33.959 33.957 34.4258 33.709 34.668 33.2129V28.6602H36.0918V35H34.75L34.7148 34.3789ZM41.3301 35C41.2676 34.8789 41.2129 34.6816 41.166 34.4082C40.7129 34.8809 40.1582 35.1172 39.502 35.1172C38.8652 35.1172 38.3457 34.9355 37.9434 34.5723C37.541 34.209 37.3398 33.7598 37.3398 33.2246C37.3398 32.5488 37.5898 32.0312 38.0898 31.6719C38.5938 31.3086 39.3125 31.127 40.2461 31.127H41.1191V30.7109C41.1191 30.3828 41.0273 30.1211 40.8438 29.9258C40.6602 29.7266 40.3809 29.627 40.0059 29.627C39.6816 29.627 39.416 29.709 39.209 29.873C39.002 30.0332 38.8984 30.2383 38.8984 30.4883H37.4746C37.4746 30.1406 37.5898 29.8164 37.8203 29.5156C38.0508 29.2109 38.3633 28.9727 38.7578 28.8008C39.1562 28.6289 39.5996 28.543 40.0879 28.543C40.8301 28.543 41.4219 28.7305 41.8633 29.1055C42.3047 29.4766 42.5312 30 42.543 30.6758V33.5352C42.543 34.1055 42.623 34.5605 42.7832 34.9004V35H41.3301ZM39.7656 33.9746C40.0469 33.9746 40.3105 33.9062 40.5566 33.7695C40.8066 33.6328 40.9941 33.4492 41.1191 33.2188V32.0234H40.3516C39.8242 32.0234 39.4277 32.1152 39.1621 32.2988C38.8965 32.4824 38.7637 32.7422 38.7637 33.0781C38.7637 33.3516 38.8535 33.5703 39.0332 33.7344C39.2168 33.8945 39.4609 33.9746 39.7656 33.9746ZM42.1562 27.623V27.6875H41.0137L40.1348 26.7734L39.2617 27.6875H38.1309V27.6113L39.7188 25.9941H40.5566L42.1562 27.623ZM38.8516 36.3711C38.8516 36.1641 38.9199 35.9902 39.0566 35.8496C39.1973 35.7129 39.3965 35.6445 39.6543 35.6445C39.9121 35.6445 40.1113 35.7129 40.252 35.8496C40.3926 35.9902 40.4629 36.1641 40.4629 36.3711C40.4629 36.5781 40.3926 36.75 40.252 36.8867C40.1113 37.0234 39.9121 37.0918 39.6543 37.0918C39.3965 37.0918 39.1973 37.0234 39.0566 36.8867C38.9199 36.75 38.8516 36.5781 38.8516 36.3711ZM45.3555 28.6602L45.3965 29.3926C45.8652 28.8262 46.4805 28.543 47.2422 28.543C48.5625 28.543 49.2344 29.2988 49.2578 30.8105V35H47.834V30.8926C47.834 30.4902 47.7461 30.1934 47.5703 30.002C47.3984 29.8066 47.1152 29.709 46.7207 29.709C46.1465 29.709 45.7188 29.9688 45.4375 30.4883V35H44.0137V28.6602H45.3555Z"
              fill="#C2CFE0"
            />
          </svg>
        </div>
      </div>
      <div
        class="drawer-item message border-bottom"
        :class="{ active: couter == 4 }"
        @click="getCovSearch(4, 'chat')"
      >
        <div class="item-image">
          <svg
            width="47"
            height="38"
            viewBox="0 0 47 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.25781 27.6641H4.59766V35H3.12695V27.6641H0.490234V26.4688H7.25781V27.6641ZM9.75977 35H8.33594V28.6602H9.75977V35ZM8.24805 27.0137C8.24805 26.7949 8.31641 26.6133 8.45312 26.4688C8.59375 26.3242 8.79297 26.252 9.05078 26.252C9.30859 26.252 9.50781 26.3242 9.64844 26.4688C9.78906 26.6133 9.85938 26.7949 9.85938 27.0137C9.85938 27.2285 9.78906 27.4082 9.64844 27.5527C9.50781 27.6934 9.30859 27.7637 9.05078 27.7637C8.79297 27.7637 8.59375 27.6934 8.45312 27.5527C8.31641 27.4082 8.24805 27.2285 8.24805 27.0137ZM12.6367 28.6602L12.6777 29.3926C13.1465 28.8262 13.7617 28.543 14.5234 28.543C15.8438 28.543 16.5156 29.2988 16.5391 30.8105V35H15.1152V30.8926C15.1152 30.4902 15.0273 30.1934 14.8516 30.002C14.6797 29.8066 14.3965 29.709 14.002 29.709C13.4277 29.709 13 29.9688 12.7188 30.4883V35H11.2949V28.6602H12.6367ZM22.3047 28.6602L22.3457 29.3926C22.8145 28.8262 23.4297 28.543 24.1914 28.543C25.5117 28.543 26.1836 29.2988 26.207 30.8105V35H24.7832V30.8926C24.7832 30.4902 24.6953 30.1934 24.5195 30.002C24.3477 29.8066 24.0645 29.709 23.6699 29.709C23.0957 29.709 22.668 29.9688 22.3867 30.4883V35H20.9629V28.6602H22.3047ZM29.0664 29.3516C29.5312 28.8125 30.1191 28.543 30.8301 28.543C32.1816 28.543 32.8672 29.3145 32.8867 30.8574V35H31.4629V30.9102C31.4629 30.4727 31.3672 30.1641 31.1758 29.9844C30.9883 29.8008 30.7109 29.709 30.3438 29.709C29.7734 29.709 29.3477 29.9629 29.0664 30.4707V35H27.6426V26H29.0664V29.3516ZM38.1191 35C38.0566 34.8789 38.002 34.6816 37.9551 34.4082C37.502 34.8809 36.9473 35.1172 36.291 35.1172C35.6543 35.1172 35.1348 34.9355 34.7324 34.5723C34.3301 34.209 34.1289 33.7598 34.1289 33.2246C34.1289 32.5488 34.3789 32.0312 34.8789 31.6719C35.3828 31.3086 36.1016 31.127 37.0352 31.127H37.9082V30.7109C37.9082 30.3828 37.8164 30.1211 37.6328 29.9258C37.4492 29.7266 37.1699 29.627 36.7949 29.627C36.4707 29.627 36.2051 29.709 35.998 29.873C35.791 30.0332 35.6875 30.2383 35.6875 30.4883H34.2637C34.2637 30.1406 34.3789 29.8164 34.6094 29.5156C34.8398 29.2109 35.1523 28.9727 35.5469 28.8008C35.9453 28.6289 36.3887 28.543 36.877 28.543C37.6191 28.543 38.2109 28.7305 38.6523 29.1055C39.0938 29.4766 39.3203 30 39.332 30.6758V33.5352C39.332 34.1055 39.4121 34.5605 39.5723 34.9004V35H38.1191ZM36.5547 33.9746C36.8359 33.9746 37.0996 33.9062 37.3457 33.7695C37.5957 33.6328 37.7832 33.4492 37.9082 33.2188V32.0234H37.1406C36.6133 32.0234 36.2168 32.1152 35.9512 32.2988C35.6855 32.4824 35.5527 32.7422 35.5527 33.0781C35.5527 33.3516 35.6426 33.5703 35.8223 33.7344C36.0059 33.8945 36.25 33.9746 36.5547 33.9746ZM38.8105 26.498C38.8105 26.877 38.6387 27.1875 38.2949 27.4297C37.9551 27.6719 37.4922 27.793 36.9062 27.793C36.3242 27.793 35.8594 27.6738 35.5117 27.4355C35.168 27.1973 34.9961 26.8848 34.9961 26.498H36.0332C36.0332 26.7012 36.1074 26.8613 36.2559 26.9785C36.4043 27.0957 36.6211 27.1543 36.9062 27.1543C37.1836 27.1543 37.3965 27.0957 37.5449 26.9785C37.6934 26.8613 37.7676 26.7012 37.7676 26.498H38.8105ZM37.1758 25.291H38.2422L37.252 26.416H36.502L37.1758 25.291ZM42.1445 28.6602L42.1855 29.3926C42.6543 28.8262 43.2695 28.543 44.0312 28.543C45.3516 28.543 46.0234 29.2988 46.0469 30.8105V35H44.623V30.8926C44.623 30.4902 44.5352 30.1934 44.3594 30.002C44.1875 29.8066 43.9043 29.709 43.5098 29.709C42.9355 29.709 42.5078 29.9688 42.2266 30.4883V35H40.8027V28.6602H42.1445Z"
              fill="#C2CFE0"
            />
            <path
              d="M16.3804 16.3781L16.0068 19.9126L18.6768 18.377"
              fill="#C2CFE0"
            />
            <path
              d="M15.9589 20L16.3421 16.3712L16.4175 16.3866L16.0547 19.8267L18.6625 18.3254L18.6912 18.4266L15.9589 20Z"
              fill="#C2CFE0"
            />
            <path
              d="M24.0001 0.0562134C18.4985 0.0562134 14.0384 4.50168 14.0384 9.98506C14.0384 15.4684 18.4985 19.9139 24.0001 19.9139C29.5017 19.9139 33.9618 15.4702 33.9618 9.98506C33.9618 4.50168 29.5005 0.0562134 24.0001 0.0562134ZM25.917 13.5679L22.1573 8.92343L18.4791 13.5802L22.1561 6.40312L25.6258 11.2158L29.5207 6.39126L25.917 13.5679Z"
              fill="#C2CFE0"
            />
            <path
              d="M24 19.9675C18.4864 19.9675 14 15.4895 14 9.98375C14 4.47973 18.4864 0 24 0C29.5136 0 34 4.47797 34 9.98375C34 15.4895 29.5136 19.9675 24 19.9675ZM24 0.111126C18.5281 0.111126 14.0766 4.54122 14.0766 9.98506C14.0766 15.4289 18.5281 19.859 24 19.859C29.4719 19.859 33.9234 15.4289 33.9234 9.98506C33.9234 4.54122 29.4719 0.111126 24 0.111126V0.111126ZM18.2372 13.9606L22.1514 6.32011L25.6285 11.1398L29.7438 6.04252L25.9231 13.6483L25.8907 13.6088L22.1574 8.99686L18.2372 13.9606ZM22.1572 8.85097L22.1824 8.88185L25.9096 13.4868L29.2993 6.73708L25.6248 11.2888L25.5997 11.2545L22.1609 6.48666L18.7209 13.2003L22.1572 8.85097Z"
              fill="#C2CFE0"
            />
          </svg>
        </div>
      </div>

      <div
        class="drawer-item have-phone"
        :class="{ active: couter == 5 }"
        @click="getCovSearch(5, 'phone')"
      >
        <div class="item-image">
          <svg
            width="54"
            height="52"
            viewBox="0 0 54 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.0312 32.2227C18.9453 33.1328 18.6094 33.8438 18.0234 34.3555C17.4375 34.8633 16.6582 35.1172 15.6855 35.1172C15.0059 35.1172 14.4062 34.957 13.8867 34.6367C13.3711 34.3125 12.9727 33.8535 12.6914 33.2598C12.4102 32.666 12.2637 31.9766 12.252 31.1914V30.3945C12.252 29.5898 12.3945 28.8809 12.6797 28.2676C12.9648 27.6543 13.373 27.1816 13.9043 26.8496C14.4395 26.5176 15.0566 26.3516 15.7559 26.3516C16.6973 26.3516 17.4551 26.6074 18.0293 27.1191C18.6035 27.6309 18.9375 28.3535 19.0312 29.2871H17.5547C17.4844 28.6738 17.3047 28.2324 17.0156 27.9629C16.7305 27.6895 16.3105 27.5527 15.7559 27.5527C15.1113 27.5527 14.6152 27.7891 14.2676 28.2617C13.9238 28.7305 13.748 29.4199 13.7402 30.3301V31.0859C13.7402 32.0078 13.9043 32.7109 14.2324 33.1953C14.5645 33.6797 15.0488 33.9219 15.6855 33.9219C16.2676 33.9219 16.7051 33.791 16.998 33.5293C17.291 33.2676 17.4766 32.832 17.5547 32.2227H19.0312ZM19.957 31.7715C19.957 31.1504 20.0801 30.5918 20.3262 30.0957C20.5723 29.5957 20.918 29.2129 21.3633 28.9473C21.8086 28.6777 22.3203 28.543 22.8984 28.543C23.7539 28.543 24.4473 28.8184 24.9785 29.3691C25.5137 29.9199 25.8027 30.6504 25.8457 31.5605L25.8516 31.8945C25.8516 32.5195 25.7305 33.0781 25.4883 33.5703C25.25 34.0625 24.9062 34.4434 24.457 34.7129C24.0117 34.9824 23.4961 35.1172 22.9102 35.1172C22.0156 35.1172 21.2988 34.8203 20.7598 34.2266C20.2246 33.6289 19.957 32.834 19.957 31.8418V31.7715ZM21.3809 31.8945C21.3809 32.5469 21.5156 33.0586 21.7852 33.4297C22.0547 33.7969 22.4297 33.9805 22.9102 33.9805C23.3906 33.9805 23.7637 33.793 24.0293 33.418C24.2988 33.043 24.4336 32.4941 24.4336 31.7715C24.4336 31.1309 24.2949 30.623 24.0176 30.248C23.7441 29.873 23.3711 29.6855 22.8984 29.6855C22.4336 29.6855 22.0645 29.8711 21.791 30.2422C21.5176 30.6094 21.3809 31.1602 21.3809 31.8945ZM23.291 26H24.9141L23.291 27.7754H22.1484L23.291 26ZM33.5977 33.2773C33.5977 33.0234 33.4922 32.8301 33.2812 32.6973C33.0742 32.5645 32.7285 32.4473 32.2441 32.3457C31.7598 32.2441 31.3555 32.1152 31.0312 31.959C30.3203 31.6152 29.9648 31.1172 29.9648 30.4648C29.9648 29.918 30.1953 29.4609 30.6562 29.0938C31.1172 28.7266 31.7031 28.543 32.4141 28.543C33.1719 28.543 33.7832 28.7305 34.248 29.1055C34.7168 29.4805 34.9512 29.9668 34.9512 30.5645H33.5273C33.5273 30.291 33.4258 30.0645 33.2227 29.8848C33.0195 29.7012 32.75 29.6094 32.4141 29.6094C32.1016 29.6094 31.8457 29.6816 31.6465 29.8262C31.4512 29.9707 31.3535 30.1641 31.3535 30.4062C31.3535 30.625 31.4453 30.7949 31.6289 30.916C31.8125 31.0371 32.1836 31.1602 32.7422 31.2852C33.3008 31.4062 33.7383 31.5527 34.0547 31.7246C34.375 31.8926 34.6113 32.0957 34.7637 32.334C34.9199 32.5723 34.998 32.8613 34.998 33.2012C34.998 33.7715 34.7617 34.2344 34.2891 34.5898C33.8164 34.9414 33.1973 35.1172 32.4316 35.1172C31.9121 35.1172 31.4492 35.0234 31.043 34.8359C30.6367 34.6484 30.3203 34.3906 30.0938 34.0625C29.8672 33.7344 29.7539 33.3809 29.7539 33.002H31.1367C31.1562 33.3379 31.2832 33.5977 31.5176 33.7812C31.752 33.9609 32.0625 34.0508 32.4492 34.0508C32.8242 34.0508 33.1094 33.9805 33.3047 33.8398C33.5 33.6953 33.5977 33.5078 33.5977 33.2773ZM35.9766 31.7715C35.9766 31.1504 36.0996 30.5918 36.3457 30.0957C36.5918 29.5957 36.9375 29.2129 37.3828 28.9473C37.8281 28.6777 38.3398 28.543 38.918 28.543C39.7734 28.543 40.4668 28.8184 40.998 29.3691C41.5332 29.9199 41.8223 30.6504 41.8652 31.5605L41.8711 31.8945C41.8711 32.5195 41.75 33.0781 41.5078 33.5703C41.2695 34.0625 40.9258 34.4434 40.4766 34.7129C40.0312 34.9824 39.5156 35.1172 38.9297 35.1172C38.0352 35.1172 37.3184 34.8203 36.7793 34.2266C36.2441 33.6289 35.9766 32.834 35.9766 31.8418V31.7715ZM37.4004 31.8945C37.4004 32.5469 37.5352 33.0586 37.8047 33.4297C38.0742 33.7969 38.4492 33.9805 38.9297 33.9805C39.4102 33.9805 39.7832 33.793 40.0488 33.418C40.3184 33.043 40.4531 32.4941 40.4531 31.7715C40.4531 31.1309 40.3145 30.623 40.0371 30.248C39.7637 29.873 39.3906 29.6855 38.918 29.6855C38.4531 29.6855 38.084 29.8711 37.8105 30.2422C37.5371 30.6094 37.4004 31.1602 37.4004 31.8945ZM38.4141 26.2988H39.3574L41.0625 27.7637H39.8203L38.8887 26.9316L37.957 27.7637H36.709L38.4141 26.2988ZM41.5078 25.2734H42.8086L41.543 26.8379H40.623L41.5078 25.2734ZM7.22461 41.8281H6.19922V49H4.91016L4.83984 48.3438C4.41406 48.8594 3.8457 49.1172 3.13477 49.1172C2.39258 49.1172 1.79102 48.8184 1.33008 48.2207C0.873047 47.623 0.644531 46.8105 0.644531 45.7832C0.644531 44.8066 0.871094 44.0234 1.32422 43.4336C1.77734 42.8398 2.38477 42.543 3.14648 42.543C3.81836 42.543 4.36133 42.7773 4.77539 43.2461V41.8281H3.30469V40.832H4.77539V40H6.19922V40.832H7.22461V41.8281ZM2.06836 45.9062C2.06836 46.5508 2.19141 47.0547 2.4375 47.418C2.6875 47.7773 3.04102 47.957 3.49805 47.957C4.08008 47.957 4.50586 47.6973 4.77539 47.1777V44.4707C4.51367 43.9629 4.0918 43.709 3.50977 43.709C3.04883 43.709 2.69336 43.8926 2.44336 44.2598C2.19336 44.623 2.06836 45.1719 2.06836 45.9062ZM9.82031 49H8.39648V42.6602H9.82031V49ZM8.30859 41.0137C8.30859 40.7949 8.37695 40.6133 8.51367 40.4688C8.6543 40.3242 8.85352 40.252 9.11133 40.252C9.36914 40.252 9.56836 40.3242 9.70898 40.4688C9.84961 40.6133 9.91992 40.7949 9.91992 41.0137C9.91992 41.2285 9.84961 41.4082 9.70898 41.5527C9.56836 41.6934 9.36914 41.7637 9.11133 41.7637C8.85352 41.7637 8.6543 41.6934 8.51367 41.5527C8.37695 41.4082 8.30859 41.2285 8.30859 41.0137ZM14.168 49.1172C13.2656 49.1172 12.5332 48.834 11.9707 48.2676C11.4121 47.6973 11.1328 46.9395 11.1328 45.9941V45.8184C11.1328 45.1855 11.2539 44.6211 11.4961 44.125C11.7422 43.625 12.0859 43.2363 12.5273 42.959C12.9688 42.6816 13.4609 42.543 14.0039 42.543C14.8672 42.543 15.5332 42.8184 16.002 43.3691C16.4746 43.9199 16.7109 44.6992 16.7109 45.707V46.2812H12.5684C12.6113 46.8047 12.7852 47.2188 13.0898 47.5234C13.3984 47.8281 13.7852 47.9805 14.25 47.9805C14.9023 47.9805 15.4336 47.7168 15.8438 47.1895L16.6113 47.9219C16.3574 48.3008 16.0176 48.5957 15.5918 48.8066C15.1699 49.0137 14.6953 49.1172 14.168 49.1172ZM13.998 43.6855C13.6074 43.6855 13.291 43.8223 13.0488 44.0957C12.8105 44.3691 12.6582 44.75 12.5918 45.2383H15.3047V45.1328C15.2734 44.6562 15.1465 44.2969 14.9238 44.0547C14.7012 43.8086 14.3926 43.6855 13.998 43.6855ZM15.9199 41.623V41.6875H14.7773L13.8984 40.7734L13.0254 41.6875H11.8945V41.6113L13.4824 39.9941H14.3203L15.9199 41.623ZM13.1484 50.4121C13.1484 50.2051 13.2168 50.0312 13.3535 49.8906C13.4941 49.7539 13.6934 49.6855 13.9512 49.6855C14.209 49.6855 14.4082 49.7539 14.5488 49.8906C14.6895 50.0312 14.7598 50.2051 14.7598 50.4121C14.7598 50.6191 14.6895 50.791 14.5488 50.9277C14.4082 51.0645 14.209 51.1328 13.9512 51.1328C13.6934 51.1328 13.4941 51.0645 13.3535 50.9277C13.2168 50.791 13.1484 50.6191 13.1484 50.4121ZM19.1426 42.6602L19.1836 43.3926C19.6523 42.8262 20.2676 42.543 21.0293 42.543C22.3496 42.543 23.0215 43.2988 23.0449 44.8105V49H21.6211V44.8926C21.6211 44.4902 21.5332 44.1934 21.3574 44.002C21.1855 43.8066 20.9023 43.709 20.5078 43.709C19.9336 43.709 19.5059 43.9688 19.2246 44.4883V49H17.8008V42.6602H19.1426ZM29.2734 41.1191V42.6602H30.3926V43.7148H29.2734V47.2539C29.2734 47.4961 29.3203 47.6719 29.4141 47.7812C29.5117 47.8867 29.6836 47.9395 29.9297 47.9395C30.0938 47.9395 30.2598 47.9199 30.4277 47.8809V48.9824C30.1035 49.0723 29.791 49.1172 29.4902 49.1172C28.3965 49.1172 27.8496 48.5137 27.8496 47.3066V43.7148H26.8066V42.6602H27.8496V41.1191H29.2734ZM32.8887 43.3516C33.3535 42.8125 33.9414 42.543 34.6523 42.543C36.0039 42.543 36.6895 43.3145 36.709 44.8574V49H35.2852V44.9102C35.2852 44.4727 35.1895 44.1641 34.998 43.9844C34.8105 43.8008 34.5332 43.709 34.166 43.709C33.5957 43.709 33.1699 43.9629 32.8887 44.4707V49H31.4648V40H32.8887V43.3516ZM37.8867 45.7715C37.8867 45.1504 38.0098 44.5918 38.2559 44.0957C38.502 43.5957 38.8477 43.2129 39.293 42.9473C39.7383 42.6777 40.25 42.543 40.8281 42.543C41.6836 42.543 42.377 42.8184 42.9082 43.3691C43.4434 43.9199 43.7324 44.6504 43.7754 45.5605L43.7812 45.8945C43.7812 46.5195 43.6602 47.0781 43.418 47.5703C43.1797 48.0625 42.8359 48.4434 42.3867 48.7129C41.9414 48.9824 41.4258 49.1172 40.8398 49.1172C39.9453 49.1172 39.2285 48.8203 38.6895 48.2266C38.1543 47.6289 37.8867 46.834 37.8867 45.8418V45.7715ZM39.3105 45.8945C39.3105 46.5469 39.4453 47.0586 39.7148 47.4297C39.9844 47.7969 40.3594 47.9805 40.8398 47.9805C41.3203 47.9805 41.6934 47.793 41.959 47.418C42.2285 47.043 42.3633 46.4941 42.3633 45.7715C42.3633 45.1309 42.2246 44.623 41.9473 44.248C41.6738 43.873 41.3008 43.6855 40.8281 43.6855C40.3633 43.6855 39.9941 43.8711 39.7207 44.2422C39.4473 44.6094 39.3105 45.1602 39.3105 45.8945ZM48.7734 49C48.7109 48.8789 48.6562 48.6816 48.6094 48.4082C48.1562 48.8809 47.6016 49.1172 46.9453 49.1172C46.3086 49.1172 45.7891 48.9355 45.3867 48.5723C44.9844 48.209 44.7832 47.7598 44.7832 47.2246C44.7832 46.5488 45.0332 46.0312 45.5332 45.6719C46.0371 45.3086 46.7559 45.127 47.6895 45.127H48.5625V44.7109C48.5625 44.3828 48.4707 44.1211 48.2871 43.9258C48.1035 43.7266 47.8242 43.627 47.4492 43.627C47.125 43.627 46.8594 43.709 46.6523 43.873C46.4453 44.0332 46.3418 44.2383 46.3418 44.4883H44.918C44.918 44.1406 45.0332 43.8164 45.2637 43.5156C45.4941 43.2109 45.8066 42.9727 46.2012 42.8008C46.5996 42.6289 47.043 42.543 47.5312 42.543C48.2734 42.543 48.8652 42.7305 49.3066 43.1055C49.748 43.4766 49.9746 44 49.9863 44.6758V47.5352C49.9863 48.1055 50.0664 48.5605 50.2266 48.9004V49H48.7734ZM47.209 47.9746C47.4902 47.9746 47.7539 47.9062 48 47.7695C48.25 47.6328 48.4375 47.4492 48.5625 47.2188V46.0234H47.7949C47.2676 46.0234 46.8711 46.1152 46.6055 46.2988C46.3398 46.4824 46.207 46.7422 46.207 47.0781C46.207 47.3516 46.2969 47.5703 46.4766 47.7344C46.6602 47.8945 46.9043 47.9746 47.209 47.9746ZM46.2949 50.3711C46.2949 50.1641 46.3633 49.9902 46.5 49.8496C46.6406 49.7129 46.8398 49.6445 47.0977 49.6445C47.3555 49.6445 47.5547 49.7129 47.6953 49.8496C47.8359 49.9902 47.9062 50.1641 47.9062 50.3711C47.9062 50.5781 47.8359 50.75 47.6953 50.8867C47.5547 51.0234 47.3555 51.0918 47.0977 51.0918C46.8398 51.0918 46.6406 51.0234 46.5 50.8867C46.3633 50.75 46.2949 50.5781 46.2949 50.3711ZM52.9922 49H51.5684V42.6602H52.9922V49ZM51.4805 41.0137C51.4805 40.7949 51.5488 40.6133 51.6855 40.4688C51.8262 40.3242 52.0254 40.252 52.2832 40.252C52.541 40.252 52.7402 40.3242 52.8809 40.4688C53.0215 40.6133 53.0918 40.7949 53.0918 41.0137C53.0918 41.2285 53.0215 41.4082 52.8809 41.5527C52.7402 41.6934 52.541 41.7637 52.2832 41.7637C52.0254 41.7637 51.8262 41.6934 51.6855 41.5527C51.5488 41.4082 51.4805 41.2285 51.4805 41.0137Z"
              fill="#C2CFE0"
            />
            <g clip-path="url(#clip0_1_472)">
              <path
                d="M35.4016 16.1113C34.9848 15.3913 34.4543 14.6714 33.9238 14.0272C33.6207 13.6483 33.2797 13.2694 32.8629 13.0041C32.3703 12.7389 31.6503 12.5873 31.1577 12.9283C30.9304 13.0799 30.7409 13.1936 30.5136 13.3451C30.3241 13.4967 30.0968 13.6104 29.9073 13.762C29.3389 14.1409 28.8463 13.9135 28.4295 13.4967C27.3685 12.4736 26.3455 11.4126 25.436 10.2379C25.095 9.82107 23.0867 7.58534 23.6551 7.01714L25.095 5.57725C25.5118 5.16043 25.5118 4.40259 25.3602 3.87213C25.2087 3.41743 24.8676 3.0006 24.5645 2.62171C24.034 1.97756 23.4277 1.29548 22.7836 0.765018C22.3289 0.386099 21.7984 0.0450603 21.23 0.00718053C20.889 -0.0307114 20.5101 0.0829643 20.2448 0.310316C20.0554 0.461883 19.8659 0.65133 19.6764 0.840802C19.0702 1.48495 18.6155 2.35648 18.3881 3.1901C18.1987 3.87215 18.1608 4.55421 18.2365 5.23626C18.3881 7.01719 19.146 8.57074 20.0554 10.0486C21.0405 11.678 22.1394 13.2693 23.3898 14.7093C25.1708 16.7176 27.52 18.9911 30.1725 19.7489C30.8167 19.9384 31.5367 20.052 32.2187 19.9763C33.0902 19.9384 33.9996 19.6352 34.7575 19.1805C34.9849 19.029 35.2122 18.8774 35.4017 18.7258C35.6669 18.4985 35.8564 18.1575 35.8943 17.8164C35.9322 17.1723 35.7048 16.6039 35.4017 16.1113L35.4016 16.1113Z"
                fill="#C2CFE0"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_472">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(17)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div
        class="drawer-item no-phone border-bottom"
        :class="{ active: couter == 6 }"
        @click="getCovSearch(6, 'no_phone')"
      >
        <div class="item-image">
          <svg
            width="54"
            height="52"
            viewBox="0 0 54 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.2891 31.3145L9.32227 32.3398V35H7.83984V26.4688H9.32227V30.4707L10.1426 29.457L12.6387 26.4688H14.4316L11.2617 30.248L14.6133 35H12.8555L10.2891 31.3145ZM16.1602 33.5C16.4258 33.5 16.6309 33.5762 16.7754 33.7285C16.9199 33.877 16.9922 34.0645 16.9922 34.291C16.9922 34.5137 16.9199 34.6992 16.7754 34.8477C16.6309 34.9922 16.4258 35.0645 16.1602 35.0645C15.9062 35.0645 15.7051 34.9922 15.5566 34.8477C15.4082 34.7031 15.334 34.5176 15.334 34.291C15.334 34.0645 15.4062 33.877 15.5508 33.7285C15.6953 33.5762 15.8984 33.5 16.1602 33.5ZM21.2285 33.9805C21.584 33.9805 21.8789 33.877 22.1133 33.6699C22.3477 33.4629 22.4727 33.207 22.4883 32.9023H23.8301C23.8145 33.2969 23.6914 33.666 23.4609 34.0098C23.2305 34.3496 22.918 34.6191 22.5234 34.8184C22.1289 35.0176 21.7031 35.1172 21.2461 35.1172C20.3594 35.1172 19.6562 34.8301 19.1367 34.2559C18.6172 33.6816 18.3574 32.8887 18.3574 31.877V31.7305C18.3574 30.7656 18.6152 29.9941 19.1309 29.416C19.6465 28.834 20.3496 28.543 21.2402 28.543C21.9941 28.543 22.6074 28.7637 23.0801 29.2051C23.5566 29.6426 23.8066 30.2188 23.8301 30.9336H22.4883C22.4727 30.5703 22.3477 30.2715 22.1133 30.0371C21.8828 29.8027 21.5879 29.6855 21.2285 29.6855C20.7676 29.6855 20.4121 29.8535 20.1621 30.1895C19.9121 30.5215 19.7852 31.0273 19.7812 31.707V31.9355C19.7812 32.623 19.9043 33.1367 20.1504 33.4766C20.4004 33.8125 20.7598 33.9805 21.2285 33.9805ZM24.6387 31.7715C24.6387 31.1504 24.7617 30.5918 25.0078 30.0957C25.2539 29.5957 25.5996 29.2129 26.0449 28.9473C26.4902 28.6777 27.002 28.543 27.5801 28.543C28.4355 28.543 29.1289 28.8184 29.6602 29.3691C30.1953 29.9199 30.4844 30.6504 30.5273 31.5605L30.5332 31.8945C30.5332 32.5195 30.4121 33.0781 30.1699 33.5703C29.9316 34.0625 29.5879 34.4434 29.1387 34.7129C28.6934 34.9824 28.1777 35.1172 27.5918 35.1172C26.6973 35.1172 25.9805 34.8203 25.4414 34.2266C24.9062 33.6289 24.6387 32.834 24.6387 31.8418V31.7715ZM26.0625 31.8945C26.0625 32.5469 26.1973 33.0586 26.4668 33.4297C26.7363 33.7969 27.1113 33.9805 27.5918 33.9805C28.0723 33.9805 28.4453 33.793 28.7109 33.418C28.9805 33.043 29.1152 32.4941 29.1152 31.7715C29.1152 31.1309 28.9766 30.623 28.6992 30.248C28.4258 29.873 28.0527 29.6855 27.5801 29.6855C27.1152 29.6855 26.7461 29.8711 26.4727 30.2422C26.1992 30.6094 26.0625 31.1602 26.0625 31.8945ZM27.9727 26H29.5957L27.9727 27.7754H26.8301L27.9727 26ZM38.2793 33.2773C38.2793 33.0234 38.1738 32.8301 37.9629 32.6973C37.7559 32.5645 37.4102 32.4473 36.9258 32.3457C36.4414 32.2441 36.0371 32.1152 35.7129 31.959C35.002 31.6152 34.6465 31.1172 34.6465 30.4648C34.6465 29.918 34.877 29.4609 35.3379 29.0938C35.7988 28.7266 36.3848 28.543 37.0957 28.543C37.8535 28.543 38.4648 28.7305 38.9297 29.1055C39.3984 29.4805 39.6328 29.9668 39.6328 30.5645H38.209C38.209 30.291 38.1074 30.0645 37.9043 29.8848C37.7012 29.7012 37.4316 29.6094 37.0957 29.6094C36.7832 29.6094 36.5273 29.6816 36.3281 29.8262C36.1328 29.9707 36.0352 30.1641 36.0352 30.4062C36.0352 30.625 36.127 30.7949 36.3105 30.916C36.4941 31.0371 36.8652 31.1602 37.4238 31.2852C37.9824 31.4062 38.4199 31.5527 38.7363 31.7246C39.0566 31.8926 39.293 32.0957 39.4453 32.334C39.6016 32.5723 39.6797 32.8613 39.6797 33.2012C39.6797 33.7715 39.4434 34.2344 38.9707 34.5898C38.498 34.9414 37.8789 35.1172 37.1133 35.1172C36.5938 35.1172 36.1309 35.0234 35.7246 34.8359C35.3184 34.6484 35.002 34.3906 34.7754 34.0625C34.5488 33.7344 34.4355 33.3809 34.4355 33.002H35.8184C35.8379 33.3379 35.9648 33.5977 36.1992 33.7812C36.4336 33.9609 36.7441 34.0508 37.1309 34.0508C37.5059 34.0508 37.791 33.9805 37.9863 33.8398C38.1816 33.6953 38.2793 33.5078 38.2793 33.2773ZM40.6582 31.7715C40.6582 31.1504 40.7812 30.5918 41.0273 30.0957C41.2734 29.5957 41.6191 29.2129 42.0645 28.9473C42.5098 28.6777 43.0215 28.543 43.5996 28.543C44.4551 28.543 45.1484 28.8184 45.6797 29.3691C46.2148 29.9199 46.5039 30.6504 46.5469 31.5605L46.5527 31.8945C46.5527 32.5195 46.4316 33.0781 46.1895 33.5703C45.9512 34.0625 45.6074 34.4434 45.1582 34.7129C44.7129 34.9824 44.1973 35.1172 43.6113 35.1172C42.7168 35.1172 42 34.8203 41.4609 34.2266C40.9258 33.6289 40.6582 32.834 40.6582 31.8418V31.7715ZM42.082 31.8945C42.082 32.5469 42.2168 33.0586 42.4863 33.4297C42.7559 33.7969 43.1309 33.9805 43.6113 33.9805C44.0918 33.9805 44.4648 33.793 44.7305 33.418C45 33.043 45.1348 32.4941 45.1348 31.7715C45.1348 31.1309 44.9961 30.623 44.7188 30.248C44.4453 29.873 44.0723 29.6855 43.5996 29.6855C43.1348 29.6855 42.7656 29.8711 42.4922 30.2422C42.2188 30.6094 42.082 31.1602 42.082 31.8945ZM43.0957 26.2988H44.0391L45.7441 27.7637H44.502L43.5703 26.9316L42.6387 27.7637H41.3906L43.0957 26.2988ZM46.1895 25.2734H47.4902L46.2246 26.8379H45.3047L46.1895 25.2734ZM7.22461 41.8281H6.19922V49H4.91016L4.83984 48.3438C4.41406 48.8594 3.8457 49.1172 3.13477 49.1172C2.39258 49.1172 1.79102 48.8184 1.33008 48.2207C0.873047 47.623 0.644531 46.8105 0.644531 45.7832C0.644531 44.8066 0.871094 44.0234 1.32422 43.4336C1.77734 42.8398 2.38477 42.543 3.14648 42.543C3.81836 42.543 4.36133 42.7773 4.77539 43.2461V41.8281H3.30469V40.832H4.77539V40H6.19922V40.832H7.22461V41.8281ZM2.06836 45.9062C2.06836 46.5508 2.19141 47.0547 2.4375 47.418C2.6875 47.7773 3.04102 47.957 3.49805 47.957C4.08008 47.957 4.50586 47.6973 4.77539 47.1777V44.4707C4.51367 43.9629 4.0918 43.709 3.50977 43.709C3.04883 43.709 2.69336 43.8926 2.44336 44.2598C2.19336 44.623 2.06836 45.1719 2.06836 45.9062ZM9.82031 49H8.39648V42.6602H9.82031V49ZM8.30859 41.0137C8.30859 40.7949 8.37695 40.6133 8.51367 40.4688C8.6543 40.3242 8.85352 40.252 9.11133 40.252C9.36914 40.252 9.56836 40.3242 9.70898 40.4688C9.84961 40.6133 9.91992 40.7949 9.91992 41.0137C9.91992 41.2285 9.84961 41.4082 9.70898 41.5527C9.56836 41.6934 9.36914 41.7637 9.11133 41.7637C8.85352 41.7637 8.6543 41.6934 8.51367 41.5527C8.37695 41.4082 8.30859 41.2285 8.30859 41.0137ZM14.168 49.1172C13.2656 49.1172 12.5332 48.834 11.9707 48.2676C11.4121 47.6973 11.1328 46.9395 11.1328 45.9941V45.8184C11.1328 45.1855 11.2539 44.6211 11.4961 44.125C11.7422 43.625 12.0859 43.2363 12.5273 42.959C12.9688 42.6816 13.4609 42.543 14.0039 42.543C14.8672 42.543 15.5332 42.8184 16.002 43.3691C16.4746 43.9199 16.7109 44.6992 16.7109 45.707V46.2812H12.5684C12.6113 46.8047 12.7852 47.2188 13.0898 47.5234C13.3984 47.8281 13.7852 47.9805 14.25 47.9805C14.9023 47.9805 15.4336 47.7168 15.8438 47.1895L16.6113 47.9219C16.3574 48.3008 16.0176 48.5957 15.5918 48.8066C15.1699 49.0137 14.6953 49.1172 14.168 49.1172ZM13.998 43.6855C13.6074 43.6855 13.291 43.8223 13.0488 44.0957C12.8105 44.3691 12.6582 44.75 12.5918 45.2383H15.3047V45.1328C15.2734 44.6562 15.1465 44.2969 14.9238 44.0547C14.7012 43.8086 14.3926 43.6855 13.998 43.6855ZM15.9199 41.623V41.6875H14.7773L13.8984 40.7734L13.0254 41.6875H11.8945V41.6113L13.4824 39.9941H14.3203L15.9199 41.623ZM13.1484 50.4121C13.1484 50.2051 13.2168 50.0312 13.3535 49.8906C13.4941 49.7539 13.6934 49.6855 13.9512 49.6855C14.209 49.6855 14.4082 49.7539 14.5488 49.8906C14.6895 50.0312 14.7598 50.2051 14.7598 50.4121C14.7598 50.6191 14.6895 50.791 14.5488 50.9277C14.4082 51.0645 14.209 51.1328 13.9512 51.1328C13.6934 51.1328 13.4941 51.0645 13.3535 50.9277C13.2168 50.791 13.1484 50.6191 13.1484 50.4121ZM19.1426 42.6602L19.1836 43.3926C19.6523 42.8262 20.2676 42.543 21.0293 42.543C22.3496 42.543 23.0215 43.2988 23.0449 44.8105V49H21.6211V44.8926C21.6211 44.4902 21.5332 44.1934 21.3574 44.002C21.1855 43.8066 20.9023 43.709 20.5078 43.709C19.9336 43.709 19.5059 43.9688 19.2246 44.4883V49H17.8008V42.6602H19.1426ZM29.2734 41.1191V42.6602H30.3926V43.7148H29.2734V47.2539C29.2734 47.4961 29.3203 47.6719 29.4141 47.7812C29.5117 47.8867 29.6836 47.9395 29.9297 47.9395C30.0938 47.9395 30.2598 47.9199 30.4277 47.8809V48.9824C30.1035 49.0723 29.791 49.1172 29.4902 49.1172C28.3965 49.1172 27.8496 48.5137 27.8496 47.3066V43.7148H26.8066V42.6602H27.8496V41.1191H29.2734ZM32.8887 43.3516C33.3535 42.8125 33.9414 42.543 34.6523 42.543C36.0039 42.543 36.6895 43.3145 36.709 44.8574V49H35.2852V44.9102C35.2852 44.4727 35.1895 44.1641 34.998 43.9844C34.8105 43.8008 34.5332 43.709 34.166 43.709C33.5957 43.709 33.1699 43.9629 32.8887 44.4707V49H31.4648V40H32.8887V43.3516ZM37.8867 45.7715C37.8867 45.1504 38.0098 44.5918 38.2559 44.0957C38.502 43.5957 38.8477 43.2129 39.293 42.9473C39.7383 42.6777 40.25 42.543 40.8281 42.543C41.6836 42.543 42.377 42.8184 42.9082 43.3691C43.4434 43.9199 43.7324 44.6504 43.7754 45.5605L43.7812 45.8945C43.7812 46.5195 43.6602 47.0781 43.418 47.5703C43.1797 48.0625 42.8359 48.4434 42.3867 48.7129C41.9414 48.9824 41.4258 49.1172 40.8398 49.1172C39.9453 49.1172 39.2285 48.8203 38.6895 48.2266C38.1543 47.6289 37.8867 46.834 37.8867 45.8418V45.7715ZM39.3105 45.8945C39.3105 46.5469 39.4453 47.0586 39.7148 47.4297C39.9844 47.7969 40.3594 47.9805 40.8398 47.9805C41.3203 47.9805 41.6934 47.793 41.959 47.418C42.2285 47.043 42.3633 46.4941 42.3633 45.7715C42.3633 45.1309 42.2246 44.623 41.9473 44.248C41.6738 43.873 41.3008 43.6855 40.8281 43.6855C40.3633 43.6855 39.9941 43.8711 39.7207 44.2422C39.4473 44.6094 39.3105 45.1602 39.3105 45.8945ZM48.7734 49C48.7109 48.8789 48.6562 48.6816 48.6094 48.4082C48.1562 48.8809 47.6016 49.1172 46.9453 49.1172C46.3086 49.1172 45.7891 48.9355 45.3867 48.5723C44.9844 48.209 44.7832 47.7598 44.7832 47.2246C44.7832 46.5488 45.0332 46.0312 45.5332 45.6719C46.0371 45.3086 46.7559 45.127 47.6895 45.127H48.5625V44.7109C48.5625 44.3828 48.4707 44.1211 48.2871 43.9258C48.1035 43.7266 47.8242 43.627 47.4492 43.627C47.125 43.627 46.8594 43.709 46.6523 43.873C46.4453 44.0332 46.3418 44.2383 46.3418 44.4883H44.918C44.918 44.1406 45.0332 43.8164 45.2637 43.5156C45.4941 43.2109 45.8066 42.9727 46.2012 42.8008C46.5996 42.6289 47.043 42.543 47.5312 42.543C48.2734 42.543 48.8652 42.7305 49.3066 43.1055C49.748 43.4766 49.9746 44 49.9863 44.6758V47.5352C49.9863 48.1055 50.0664 48.5605 50.2266 48.9004V49H48.7734ZM47.209 47.9746C47.4902 47.9746 47.7539 47.9062 48 47.7695C48.25 47.6328 48.4375 47.4492 48.5625 47.2188V46.0234H47.7949C47.2676 46.0234 46.8711 46.1152 46.6055 46.2988C46.3398 46.4824 46.207 46.7422 46.207 47.0781C46.207 47.3516 46.2969 47.5703 46.4766 47.7344C46.6602 47.8945 46.9043 47.9746 47.209 47.9746ZM46.2949 50.3711C46.2949 50.1641 46.3633 49.9902 46.5 49.8496C46.6406 49.7129 46.8398 49.6445 47.0977 49.6445C47.3555 49.6445 47.5547 49.7129 47.6953 49.8496C47.8359 49.9902 47.9062 50.1641 47.9062 50.3711C47.9062 50.5781 47.8359 50.75 47.6953 50.8867C47.5547 51.0234 47.3555 51.0918 47.0977 51.0918C46.8398 51.0918 46.6406 51.0234 46.5 50.8867C46.3633 50.75 46.2949 50.5781 46.2949 50.3711ZM52.9922 49H51.5684V42.6602H52.9922V49ZM51.4805 41.0137C51.4805 40.7949 51.5488 40.6133 51.6855 40.4688C51.8262 40.3242 52.0254 40.252 52.2832 40.252C52.541 40.252 52.7402 40.3242 52.8809 40.4688C53.0215 40.6133 53.0918 40.7949 53.0918 41.0137C53.0918 41.2285 53.0215 41.4082 52.8809 41.5527C52.7402 41.6934 52.541 41.7637 52.2832 41.7637C52.0254 41.7637 51.8262 41.6934 51.6855 41.5527C51.5488 41.4082 51.4805 41.2285 51.4805 41.0137Z"
              fill="#C2CFE0"
            />
            <path
              d="M25.421 9.22126C25.1052 8.46303 25.0633 7.89478 25.4843 7.66371C25.5682 7.62177 25.8421 7.47456 26.2631 7.28459C26.6628 7.09545 26.8528 6.61107 26.6628 6.19002L25.7993 4.19002C25.6521 3.8323 25.273 3.64232 24.9152 3.6851C24.4103 3.76898 23.8626 3.95895 23.5888 4.12754C22.2203 4.92771 22.2203 7.93849 23.6726 10.9482L25.421 9.22126Z"
              fill="#C2CFE0"
            />
            <path
              d="M30.2632 12.421C29.9893 12.0633 29.4844 11.9786 29.1267 12.2319C28.7475 12.4844 28.4737 12.6743 28.4112 12.7163C28.0535 12.9268 27.653 12.6743 27.2114 12.1686L25.5691 13.8109C27.3166 15.8322 29.3586 16.8001 30.5379 16.1052C30.8118 15.958 31.2534 15.5789 31.5692 15.1792C31.8011 14.8848 31.8216 14.4637 31.5906 14.1685L30.2632 12.421Z"
              fill="#C2CFE0"
            />
            <path
              d="M27 0C21.4844 0 17 4.48442 17 10C17 15.5156 21.4844 20 27 20C32.5156 20 37 15.5156 37 10C37 4.48442 32.5156 0 27 0ZM27 1.53701C29.0633 1.53701 30.9581 2.27385 32.4318 3.51562L20.4952 15.4318C19.2739 13.9581 18.5165 12.0634 18.5165 10C18.5371 5.32657 22.3267 1.53709 27.0001 1.53709L27 1.53701ZM27 18.4629C24.9367 18.4629 23.0419 17.7261 21.5682 16.4843L33.4844 4.56808C34.7056 6.04177 35.463 7.93651 35.463 9.99987C35.463 14.6733 31.6736 18.4628 27.0001 18.4628L27 18.4629Z"
              fill="#C2CFE0"
            />
          </svg>
        </div>
      </div>

      <div
        class="drawer-item not-answered"
        :class="{ active: couter == 7 }"
        @click="getCovSearch(7, 'new')"
      >
        <div class="item-image">
          <svg
            width="62"
            height="38"
            viewBox="0 0 62 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.38086 32.2227C7.29492 33.1328 6.95898 33.8438 6.37305 34.3555C5.78711 34.8633 5.00781 35.1172 4.03516 35.1172C3.35547 35.1172 2.75586 34.957 2.23633 34.6367C1.7207 34.3125 1.32227 33.8535 1.04102 33.2598C0.759766 32.666 0.613281 31.9766 0.601562 31.1914V30.3945C0.601562 29.5898 0.744141 28.8809 1.0293 28.2676C1.31445 27.6543 1.72266 27.1816 2.25391 26.8496C2.78906 26.5176 3.40625 26.3516 4.10547 26.3516C5.04688 26.3516 5.80469 26.6074 6.37891 27.1191C6.95312 27.6309 7.28711 28.3535 7.38086 29.2871H5.9043C5.83398 28.6738 5.6543 28.2324 5.36523 27.9629C5.08008 27.6895 4.66016 27.5527 4.10547 27.5527C3.46094 27.5527 2.96484 27.7891 2.61719 28.2617C2.27344 28.7305 2.09766 29.4199 2.08984 30.3301V31.0859C2.08984 32.0078 2.25391 32.7109 2.58203 33.1953C2.91406 33.6797 3.39844 33.9219 4.03516 33.9219C4.61719 33.9219 5.05469 33.791 5.34766 33.5293C5.64062 33.2676 5.82617 32.832 5.9043 32.2227H7.38086ZM9.97656 29.3516C10.4414 28.8125 11.0293 28.543 11.7402 28.543C13.0918 28.543 13.7773 29.3145 13.7969 30.8574V35H12.373V30.9102C12.373 30.4727 12.2773 30.1641 12.0859 29.9844C11.8984 29.8008 11.6211 29.709 11.2539 29.709C10.6836 29.709 10.2578 29.9629 9.97656 30.4707V35H8.55273V26H9.97656V29.3516ZM22.2461 28.1387C22.2461 28.834 22.1055 29.3438 21.8242 29.668C21.5469 29.9883 21.0918 30.1699 20.459 30.2129V35H19.1172L19.082 34.3789C18.6641 34.8711 18.0703 35.1172 17.3008 35.1172C16.6133 35.1172 16.0918 34.916 15.7363 34.5137C15.3848 34.1113 15.209 33.5293 15.209 32.7676V28.6602H16.6328V32.75C16.6328 33.5547 16.9668 33.957 17.6348 33.957C18.3262 33.957 18.793 33.709 19.0352 33.2129V28.6602H20.459V29.457C20.7402 29.4297 20.9434 29.3516 21.0684 29.2227C21.1973 29.0938 21.2715 28.8809 21.291 28.584L21.3027 28.1387H22.2461ZM26.4473 35C26.3848 34.8789 26.3301 34.6816 26.2832 34.4082C25.8301 34.8809 25.2754 35.1172 24.6191 35.1172C23.9824 35.1172 23.4629 34.9355 23.0605 34.5723C22.6582 34.209 22.457 33.7598 22.457 33.2246C22.457 32.5488 22.707 32.0312 23.207 31.6719C23.7109 31.3086 24.4297 31.127 25.3633 31.127H26.2363V30.7109C26.2363 30.3828 26.1445 30.1211 25.9609 29.9258C25.7773 29.7266 25.498 29.627 25.123 29.627C24.7988 29.627 24.5332 29.709 24.3262 29.873C24.1191 30.0332 24.0156 30.2383 24.0156 30.4883H22.5918C22.5918 30.1406 22.707 29.8164 22.9375 29.5156C23.168 29.2109 23.4805 28.9727 23.875 28.8008C24.2734 28.6289 24.7168 28.543 25.2051 28.543C25.9473 28.543 26.5391 28.7305 26.9805 29.1055C27.4219 29.4766 27.6484 30 27.6602 30.6758V33.5352C27.6602 34.1055 27.7402 34.5605 27.9004 34.9004V35H26.4473ZM24.8828 33.9746C25.1641 33.9746 25.4277 33.9062 25.6738 33.7695C25.9238 33.6328 26.1113 33.4492 26.2363 33.2188V32.0234H25.4688C24.9414 32.0234 24.5449 32.1152 24.2793 32.2988C24.0137 32.4824 23.8809 32.7422 23.8809 33.0781C23.8809 33.3516 23.9707 33.5703 24.1504 33.7344C24.334 33.8945 24.5781 33.9746 24.8828 33.9746ZM33.9238 27.1191V28.6602H35.043V29.7148H33.9238V33.2539C33.9238 33.4961 33.9707 33.6719 34.0645 33.7812C34.1621 33.8867 34.334 33.9395 34.5801 33.9395C34.7441 33.9395 34.9102 33.9199 35.0781 33.8809V34.9824C34.7539 35.0723 34.4414 35.1172 34.1406 35.1172C33.0469 35.1172 32.5 34.5137 32.5 33.3066V29.7148H31.457V28.6602H32.5V27.1191H33.9238ZM39.4551 29.9609C39.2676 29.9297 39.0742 29.9141 38.875 29.9141C38.2227 29.9141 37.7832 30.1641 37.5566 30.6641V35H36.1328V28.6602H37.4922L37.5273 29.3691C37.8711 28.8184 38.3477 28.543 38.957 28.543C39.1602 28.543 39.3281 28.5703 39.4609 28.625L39.4551 29.9609ZM43.9668 35C43.9043 34.8789 43.8496 34.6816 43.8027 34.4082C43.3496 34.8809 42.7949 35.1172 42.1387 35.1172C41.502 35.1172 40.9824 34.9355 40.5801 34.5723C40.1777 34.209 39.9766 33.7598 39.9766 33.2246C39.9766 32.5488 40.2266 32.0312 40.7266 31.6719C41.2305 31.3086 41.9492 31.127 42.8828 31.127H43.7559V30.7109C43.7559 30.3828 43.6641 30.1211 43.4805 29.9258C43.2969 29.7266 43.0176 29.627 42.6426 29.627C42.3184 29.627 42.0527 29.709 41.8457 29.873C41.6387 30.0332 41.5352 30.2383 41.5352 30.4883H40.1113C40.1113 30.1406 40.2266 29.8164 40.457 29.5156C40.6875 29.2109 41 28.9727 41.3945 28.8008C41.793 28.6289 42.2363 28.543 42.7246 28.543C43.4668 28.543 44.0586 28.7305 44.5 29.1055C44.9414 29.4766 45.168 30 45.1797 30.6758V33.5352C45.1797 34.1055 45.2598 34.5605 45.4199 34.9004V35H43.9668ZM42.4023 33.9746C42.6836 33.9746 42.9473 33.9062 43.1934 33.7695C43.4434 33.6328 43.6309 33.4492 43.7559 33.2188V32.0234H42.9883C42.4609 32.0234 42.0645 32.1152 41.7988 32.2988C41.5332 32.4824 41.4004 32.7422 41.4004 33.0781C41.4004 33.3516 41.4902 33.5703 41.6699 33.7344C41.8535 33.8945 42.0977 33.9746 42.4023 33.9746ZM42.2617 27.6172L42.2207 26.7617C42.5059 26.7422 42.7109 26.7051 42.8359 26.6504C42.9648 26.5957 43.0293 26.5 43.0293 26.3633C43.0293 26.082 42.7363 25.9414 42.1504 25.9414L42.1914 25.2207C42.8516 25.2207 43.3477 25.3223 43.6797 25.5254C44.0156 25.7285 44.1836 26.002 44.1836 26.3457C44.1836 26.5801 44.1074 26.7734 43.9551 26.9258C43.8027 27.0781 43.5859 27.1738 43.3047 27.2129V27.6172H42.2617ZM51.1738 35H49.75V26H51.1738V35ZM52.4629 31.7715C52.4629 31.1426 52.584 30.582 52.8262 30.0898C53.0723 29.5938 53.418 29.2129 53.8633 28.9473C54.3086 28.6777 54.8203 28.543 55.3984 28.543C56.2773 28.543 56.9863 28.834 57.5254 29.416C57.7324 29.3418 57.8828 29.2012 57.9766 28.9941C58.0703 28.7871 58.1172 28.4609 58.1172 28.0156H59.0957C59.0957 28.5391 59.0098 28.9766 58.8379 29.3281C58.666 29.6758 58.3789 29.9219 57.9766 30.0664C58.2227 30.5547 58.3496 31.1074 58.3574 31.7246V31.8945C58.3574 32.5195 58.2363 33.0781 57.9941 33.5703C57.7559 34.0625 57.4102 34.4434 56.957 34.7129C56.5078 34.9824 55.9922 35.1172 55.4102 35.1172C54.5234 35.1172 53.8105 34.8223 53.2715 34.2324C52.7324 33.6426 52.4629 32.8457 52.4629 31.8418V31.7715ZM53.8809 31.8945C53.8809 32.5469 54.0156 33.0586 54.2852 33.4297C54.5547 33.7969 54.9297 33.9805 55.4102 33.9805C55.8906 33.9805 56.2637 33.793 56.5293 33.418C56.7988 33.043 56.9336 32.4941 56.9336 31.7715C56.9336 31.1191 56.7949 30.6094 56.5176 30.2422C56.2441 29.8711 55.8711 29.6855 55.3984 29.6855C54.9336 29.6855 54.5645 29.8711 54.291 30.2422C54.0176 30.6094 53.8809 31.1602 53.8809 31.8945ZM56.1367 27.7754H54.9531L53.3711 26H54.9941L56.1367 27.7754ZM61.1699 35H59.7461V28.6602H61.1699V35ZM59.6582 27.0137C59.6582 26.7949 59.7266 26.6133 59.8633 26.4688C60.0039 26.3242 60.2031 26.252 60.4609 26.252C60.7188 26.252 60.918 26.3242 61.0586 26.4688C61.1992 26.6133 61.2695 26.7949 61.2695 27.0137C61.2695 27.2285 61.1992 27.4082 61.0586 27.5527C60.918 27.6934 60.7188 27.7637 60.4609 27.7637C60.2031 27.7637 60.0039 27.6934 59.8633 27.5527C59.7266 27.4082 59.6582 27.2285 59.6582 27.0137Z"
              fill="#C2CFE0"
            />
            <g clip-path="url(#clip0_1_483)">
              <path
                d="M38.7057 0H22.8877C21.6239 0 20.6 1.02383 20.6 2.28767V13.4859C20.6 14.7498 21.6239 15.7736 22.8877 15.7736H25.0443V19.543C25.0443 19.9132 25.4579 20.1311 25.7635 19.9132L31.8861 15.7736H38.7058C39.9696 15.7736 40.9935 14.7498 40.9935 13.486V2.28771C40.9935 1.02387 39.9696 4.35299e-05 38.7058 4.35299e-05L38.7057 0ZM35.3501 8.91058H30.0989L31.8853 10.697L30.4469 12.1353L27.5065 9.17177L26.2214 7.86453L27.6589 6.42706L29.184 4.92409L30.4691 3.63898L31.9074 5.0773L30.121 6.86368H35.35L35.3501 8.91058Z"
                fill="#C2CFE0"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_483">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(21)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div
        class="drawer-item filter-time border-bottom"
        :class="{ active: couter == 8 }"
      >
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="item-image" v-bind="attrs" v-on="on">
              <svg
                width="64"
                height="52"
                viewBox="0 0 64 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5898 27.6641H10.9297V35H9.45898V27.6641H6.82227V26.4688H13.5898V27.6641ZM15.9805 29.3516C16.4453 28.8125 17.0332 28.543 17.7441 28.543C19.0957 28.543 19.7812 29.3145 19.8008 30.8574V35H18.377V30.9102C18.377 30.4727 18.2812 30.1641 18.0898 29.9844C17.9023 29.8008 17.625 29.709 17.2578 29.709C16.6875 29.709 16.2617 29.9629 15.9805 30.4707V35H14.5566V26H15.9805V29.3516ZM24.0371 35.1172C23.1348 35.1172 22.4023 34.834 21.8398 34.2676C21.2812 33.6973 21.002 32.9395 21.002 31.9941V31.8184C21.002 31.1855 21.123 30.6211 21.3652 30.125C21.6113 29.625 21.9551 29.2363 22.3965 28.959C22.8379 28.6816 23.3301 28.543 23.873 28.543C24.7363 28.543 25.4023 28.8184 25.8711 29.3691C26.3438 29.9199 26.5801 30.6992 26.5801 31.707V32.2812H22.4375C22.4805 32.8047 22.6543 33.2188 22.959 33.5234C23.2676 33.8281 23.6543 33.9805 24.1191 33.9805C24.7715 33.9805 25.3027 33.7168 25.7129 33.1895L26.4805 33.9219C26.2266 34.3008 25.8867 34.5957 25.4609 34.8066C25.0391 35.0137 24.5645 35.1172 24.0371 35.1172ZM23.8672 29.6855C23.4766 29.6855 23.1602 29.8223 22.918 30.0957C22.6797 30.3691 22.5273 30.75 22.4609 31.2383H25.1738V31.1328C25.1426 30.6562 25.0156 30.2969 24.793 30.0547C24.5703 29.8086 24.2617 29.6855 23.8672 29.6855ZM27.4238 31.7715C27.4238 31.1504 27.5469 30.5918 27.793 30.0957C28.0391 29.5957 28.3848 29.2129 28.8301 28.9473C29.2754 28.6777 29.7871 28.543 30.3652 28.543C31.2207 28.543 31.9141 28.8184 32.4453 29.3691C32.9805 29.9199 33.2695 30.6504 33.3125 31.5605L33.3184 31.8945C33.3184 32.5195 33.1973 33.0781 32.9551 33.5703C32.7168 34.0625 32.373 34.4434 31.9238 34.7129C31.4785 34.9824 30.9629 35.1172 30.377 35.1172C29.4824 35.1172 28.7656 34.8203 28.2266 34.2266C27.6914 33.6289 27.4238 32.834 27.4238 31.8418V31.7715ZM28.8477 31.8945C28.8477 32.5469 28.9824 33.0586 29.252 33.4297C29.5215 33.7969 29.8965 33.9805 30.377 33.9805C30.8574 33.9805 31.2305 33.793 31.4961 33.418C31.7656 33.043 31.9004 32.4941 31.9004 31.7715C31.9004 31.1309 31.7617 30.623 31.4844 30.248C31.2109 29.873 30.8379 29.6855 30.3652 29.6855C29.9004 29.6855 29.5312 29.8711 29.2578 30.2422C28.9844 30.6094 28.8477 31.1602 28.8477 31.8945ZM39.2949 27.1191V28.6602H40.4141V29.7148H39.2949V33.2539C39.2949 33.4961 39.3418 33.6719 39.4355 33.7812C39.5332 33.8867 39.7051 33.9395 39.9512 33.9395C40.1152 33.9395 40.2812 33.9199 40.4492 33.8809V34.9824C40.125 35.0723 39.8125 35.1172 39.5117 35.1172C38.418 35.1172 37.8711 34.5137 37.8711 33.3066V29.7148H36.8281V28.6602H37.8711V27.1191H39.2949ZM42.9102 29.3516C43.375 28.8125 43.9629 28.543 44.6738 28.543C46.0254 28.543 46.7109 29.3145 46.7305 30.8574V35H45.3066V30.9102C45.3066 30.4727 45.2109 30.1641 45.0195 29.9844C44.832 29.8008 44.5547 29.709 44.1875 29.709C43.6172 29.709 43.1914 29.9629 42.9102 30.4707V35H41.4863V26H42.9102V29.3516ZM47.9082 31.7715C47.9082 31.1426 48.0293 30.582 48.2715 30.0898C48.5176 29.5938 48.8633 29.2129 49.3086 28.9473C49.7539 28.6777 50.2656 28.543 50.8438 28.543C51.7227 28.543 52.4316 28.834 52.9707 29.416C53.1777 29.3418 53.3281 29.2012 53.4219 28.9941C53.5156 28.7871 53.5625 28.4609 53.5625 28.0156H54.541C54.541 28.5391 54.4551 28.9766 54.2832 29.3281C54.1113 29.6758 53.8242 29.9219 53.4219 30.0664C53.668 30.5547 53.7949 31.1074 53.8027 31.7246V31.8945C53.8027 32.5195 53.6816 33.0781 53.4395 33.5703C53.2012 34.0625 52.8555 34.4434 52.4023 34.7129C51.9531 34.9824 51.4375 35.1172 50.8555 35.1172C49.9688 35.1172 49.2559 34.8223 48.7168 34.2324C48.1777 33.6426 47.9082 32.8457 47.9082 31.8418V31.7715ZM49.3262 31.8945C49.3262 32.5469 49.4609 33.0586 49.7305 33.4297C50 33.7969 50.375 33.9805 50.8555 33.9805C51.3359 33.9805 51.709 33.793 51.9746 33.418C52.2441 33.043 52.3789 32.4941 52.3789 31.7715C52.3789 31.1191 52.2402 30.6094 51.9629 30.2422C51.6895 29.8711 51.3164 29.6855 50.8438 29.6855C50.3789 29.6855 50.0098 29.8711 49.7363 30.2422C49.4629 30.6094 49.3262 31.1602 49.3262 31.8945ZM51.582 27.7754H50.3984L48.8164 26H50.4395L51.582 27.7754ZM56.6152 35H55.1914V28.6602H56.6152V35ZM55.1035 27.0137C55.1035 26.7949 55.1719 26.6133 55.3086 26.4688C55.4492 26.3242 55.6484 26.252 55.9062 26.252C56.1641 26.252 56.3633 26.3242 56.5039 26.4688C56.6445 26.6133 56.7148 26.7949 56.7148 27.0137C56.7148 27.2285 56.6445 27.4082 56.5039 27.5527C56.3633 27.6934 56.1641 27.7637 55.9062 27.7637C55.6484 27.7637 55.4492 27.6934 55.3086 27.5527C55.1719 27.4082 55.1035 27.2285 55.1035 27.0137ZM20.9551 45.7832C20.9551 44.7988 21.1855 44.0137 21.6465 43.4277C22.1113 42.8379 22.7266 42.543 23.4922 42.543C24.2148 42.543 24.7832 42.7949 25.1973 43.2988L25.2617 42.6602H26.5449V48.8066C26.5449 49.6387 26.2852 50.2949 25.7656 50.7754C25.25 51.2559 24.5527 51.4961 23.6738 51.4961C23.209 51.4961 22.7539 51.3984 22.3086 51.2031C21.8672 51.0117 21.5312 50.7598 21.3008 50.4473L21.9746 49.5918C22.4121 50.1113 22.9512 50.3711 23.5918 50.3711C24.0645 50.3711 24.4375 50.2422 24.7109 49.9844C24.9844 49.7305 25.1211 49.3555 25.1211 48.8594V48.4316C24.7109 48.8887 24.1641 49.1172 23.4805 49.1172C22.7383 49.1172 22.1309 48.8223 21.6582 48.2324C21.1895 47.6426 20.9551 46.8262 20.9551 45.7832ZM22.373 45.9062C22.373 46.543 22.502 47.0449 22.7598 47.4121C23.0215 47.7754 23.3828 47.957 23.8438 47.957C24.418 47.957 24.8438 47.7109 25.1211 47.2188V44.4297C24.8516 43.9492 24.4297 43.709 23.8555 43.709C23.3867 43.709 23.0215 43.8945 22.7598 44.2656C22.502 44.6367 22.373 45.1836 22.373 45.9062ZM29.5273 49H28.1035V42.6602H29.5273V49ZM28.0156 41.0137C28.0156 40.7949 28.084 40.6133 28.2207 40.4688C28.3613 40.3242 28.5605 40.252 28.8184 40.252C29.0762 40.252 29.2754 40.3242 29.416 40.4688C29.5566 40.6133 29.627 40.7949 29.627 41.0137C29.627 41.2285 29.5566 41.4082 29.416 41.5527C29.2754 41.6934 29.0762 41.7637 28.8184 41.7637C28.5605 41.7637 28.3613 41.6934 28.2207 41.5527C28.084 41.4082 28.0156 41.2285 28.0156 41.0137ZM34.8711 49C34.8086 48.8789 34.7539 48.6816 34.707 48.4082C34.2539 48.8809 33.6992 49.1172 33.043 49.1172C32.4062 49.1172 31.8867 48.9355 31.4844 48.5723C31.082 48.209 30.8809 47.7598 30.8809 47.2246C30.8809 46.5488 31.1309 46.0312 31.6309 45.6719C32.1348 45.3086 32.8535 45.127 33.7871 45.127H34.6602V44.7109C34.6602 44.3828 34.5684 44.1211 34.3848 43.9258C34.2012 43.7266 33.9219 43.627 33.5469 43.627C33.2227 43.627 32.957 43.709 32.75 43.873C32.543 44.0332 32.4395 44.2383 32.4395 44.4883H31.0156C31.0156 44.1406 31.1309 43.8164 31.3613 43.5156C31.5918 43.2109 31.9043 42.9727 32.2988 42.8008C32.6973 42.6289 33.1406 42.543 33.6289 42.543C34.3711 42.543 34.9629 42.7305 35.4043 43.1055C35.8457 43.4766 36.0723 44 36.084 44.6758V47.5352C36.084 48.1055 36.1641 48.5605 36.3242 48.9004V49H34.8711ZM33.3066 47.9746C33.5879 47.9746 33.8516 47.9062 34.0977 47.7695C34.3477 47.6328 34.5352 47.4492 34.6602 47.2188V46.0234H33.8926C33.3652 46.0234 32.9688 46.1152 32.7031 46.2988C32.4375 46.4824 32.3047 46.7422 32.3047 47.0781C32.3047 47.3516 32.3945 47.5703 32.5742 47.7344C32.7578 47.8945 33.002 47.9746 33.3066 47.9746ZM38.8965 42.6602L38.9375 43.3926C39.4062 42.8262 40.0215 42.543 40.7832 42.543C42.1035 42.543 42.7754 43.2988 42.7988 44.8105V49H41.375V44.8926C41.375 44.4902 41.2871 44.1934 41.1113 44.002C40.9395 43.8066 40.6562 43.709 40.2617 43.709C39.6875 43.709 39.2598 43.9688 38.9785 44.4883V49H37.5547V42.6602H38.8965Z"
                  fill="#C2CFE0"
                />
                <g clip-path="url(#clip0_1_494)">
                  <path
                    d="M24.491 3.80429C23.6732 3.80429 23 4.47582 23 5.29282V8.05878H43V5.29282C43 4.47584 42.3293 3.80429 41.5115 3.80429H24.491ZM23 8.90812V18.0588C23 18.8766 23.6732 19.5489 24.491 19.5489H41.5114C42.3293 19.5489 43 18.8766 43 18.0588V8.90812H23ZM25.554 10.1872H27.6826C27.7948 10.1872 27.9036 10.2321 27.9834 10.3119C28.0632 10.3917 28.1081 10.4997 28.1081 10.6127V12.7404C28.1081 12.8534 28.0632 12.9623 27.9834 13.0421C27.9036 13.1219 27.7948 13.1668 27.6826 13.1659H25.554C25.3188 13.1659 25.1285 12.9756 25.1285 12.7404V10.6128C25.1285 10.3775 25.3188 10.1872 25.554 10.1872V10.1872ZM31.937 10.1872H34.0647C34.1777 10.1872 34.2858 10.2321 34.3656 10.3119C34.4453 10.3917 34.4902 10.4997 34.4902 10.6127V12.7404C34.4902 12.8534 34.4453 12.9623 34.3656 13.0421C34.2858 13.1219 34.1777 13.1668 34.0647 13.1659H31.937C31.7018 13.1659 31.5115 12.9756 31.5115 12.7404V10.6128C31.5115 10.3775 31.7018 10.1872 31.937 10.1872V10.1872ZM38.32 10.1872H40.4477C40.5607 10.1872 40.6696 10.2321 40.7494 10.3119C40.8291 10.3917 40.874 10.4997 40.874 10.6127V12.7404C40.874 12.8534 40.8291 12.9623 40.7494 13.0421C40.6696 13.1219 40.5607 13.1668 40.4477 13.1659H38.32C38.0848 13.1659 37.8945 12.9756 37.8945 12.7404V10.6128C37.8945 10.3775 38.0848 10.1872 38.32 10.1872V10.1872ZM25.554 14.44H27.6826C27.7948 14.44 27.9036 14.4849 27.9834 14.5646C28.0632 14.6444 28.1081 14.7533 28.1081 14.8655V16.994C28.1081 17.1071 28.0632 17.2151 27.9834 17.2949C27.9036 17.3747 27.7948 17.4196 27.6826 17.4196H25.554C25.3188 17.4196 25.1285 17.2292 25.1285 16.994V14.8655C25.1285 14.6311 25.3188 14.4408 25.554 14.44V14.44ZM31.937 14.44H34.0647C34.1777 14.44 34.2858 14.4849 34.3656 14.5646C34.4453 14.6444 34.4902 14.7533 34.4902 14.8655V16.994C34.4902 17.1071 34.4453 17.2151 34.3656 17.2949C34.2858 17.3747 34.1777 17.4196 34.0647 17.4196H31.937C31.7018 17.4196 31.5115 17.2292 31.5115 16.994V14.8655C31.5115 14.6311 31.7018 14.4408 31.937 14.44V14.44ZM38.32 14.44H40.4477C40.5607 14.44 40.6696 14.4849 40.7494 14.5646C40.8291 14.6444 40.874 14.7533 40.874 14.8655V16.994C40.874 17.1071 40.8291 17.2151 40.7494 17.2949C40.6696 17.3747 40.5607 17.4196 40.4477 17.4196H38.32C38.0848 17.4196 37.8945 17.2292 37.8945 16.994V14.8655C37.8945 14.6311 38.0848 14.4408 38.32 14.44V14.44Z"
                    fill="#C2CFE0"
                  />
                  <path
                    d="M26.6112 0.400036C26.376 0.403361 26.1882 0.597011 26.1915 0.832206V2.95323H27.0426V0.832206C27.0459 0.592015 26.8506 0.396696 26.6112 0.400036Z"
                    fill="#C2CFE0"
                  />
                  <path
                    d="M39.3772 0.400036C39.142 0.403361 38.9541 0.597011 38.9574 0.832206V2.95323H39.8085V0.832206C39.8118 0.592015 39.6165 0.396696 39.3772 0.400036Z"
                    fill="#C2CFE0"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_494">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(23)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </template>
          <DatePicker
            v-model="date"
            :value="null"
            color="red"
            is-range
            mode="dateTime"
            :columns="2"
          />
          <div class="button-calender">
            <v-btn text @click="menu = false"> Bỏ qua </v-btn>
            <v-btn
              text
              color="primary"
              @click="searchDate(), $refs.menu.save(date)"
            >
              Lọc
            </v-btn>
          </div>
        </v-menu>
      </div>

      <div class="drawer-item channel" :class="{ active: couter == 9 }">
        <v-menu
          right
          ref="menuTwo"
          v-model="menuTwo"
          :close-on-content-click="false"
          :return-value.sync="selected"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="item-image" v-bind="attrs" v-on="on">
              <svg
                width="64"
                height="38"
                viewBox="0 0 64 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.7109 31.3145L20.7441 32.3398V35H19.2617V26.4688H20.7441V30.4707L21.5645 29.457L24.0605 26.4688H25.8535L22.6836 30.248L26.0352 35H24.2773L21.7109 31.3145ZM29.334 35.1172C28.4316 35.1172 27.6992 34.834 27.1367 34.2676C26.5781 33.6973 26.2988 32.9395 26.2988 31.9941V31.8184C26.2988 31.1855 26.4199 30.6211 26.6621 30.125C26.9082 29.625 27.252 29.2363 27.6934 28.959C28.1348 28.6816 28.627 28.543 29.1699 28.543C30.0332 28.543 30.6992 28.8184 31.168 29.3691C31.6406 29.9199 31.877 30.6992 31.877 31.707V32.2812H27.7344C27.7773 32.8047 27.9512 33.2188 28.2559 33.5234C28.5645 33.8281 28.9512 33.9805 29.416 33.9805C30.0684 33.9805 30.5996 33.7168 31.0098 33.1895L31.7773 33.9219C31.5234 34.3008 31.1836 34.5957 30.7578 34.8066C30.3359 35.0137 29.8613 35.1172 29.334 35.1172ZM29.1641 29.6855C28.7734 29.6855 28.457 29.8223 28.2148 30.0957C27.9766 30.3691 27.8242 30.75 27.7578 31.2383H30.4707V31.1328C30.4395 30.6562 30.3125 30.2969 30.0898 30.0547C29.8672 29.8086 29.5586 29.6855 29.1641 29.6855ZM31.0859 27.623V27.6875H29.9434L29.0645 26.7734L28.1914 27.6875H27.0605V27.6113L28.6484 25.9941H29.4863L31.0859 27.623ZM34.3086 28.6602L34.3496 29.3926C34.8184 28.8262 35.4336 28.543 36.1953 28.543C37.5156 28.543 38.1875 29.2988 38.2109 30.8105V35H36.7871V30.8926C36.7871 30.4902 36.6992 30.1934 36.5234 30.002C36.3516 29.8066 36.0684 29.709 35.6738 29.709C35.0996 29.709 34.6719 29.9688 34.3906 30.4883V35H32.9668V28.6602H34.3086ZM41.0703 29.3516C41.5352 28.8125 42.123 28.543 42.834 28.543C44.1855 28.543 44.8711 29.3145 44.8906 30.8574V35H43.4668V30.9102C43.4668 30.4727 43.3711 30.1641 43.1797 29.9844C42.9922 29.8008 42.7148 29.709 42.3477 29.709C41.7773 29.709 41.3516 29.9629 41.0703 30.4707V35H39.6465V26H41.0703V29.3516Z"
                  fill="#C2CFE0"
                />
                <path
                  d="M34.9734 3.66501L32.07 8.69418L33.5134 9.52751L36.4167 4.49834C39.8917 6.80834 41.6717 10.3983 40.2167 12.9167C38.6667 15.6017 34.2259 15.7125 30.2917 13.4417C26.3575 11.1683 24.2334 7.26751 25.7834 4.58334C27.2375 2.06418 31.2359 1.81084 34.9734 3.66501ZM36.2367 1.47751L37.68 2.31084L36.43 4.47584L34.9867 3.64251L36.2367 1.47751ZM28.61 16.6667H37.1667V18.3333H27.1809C27.0321 18.3363 26.8853 18.2992 26.7558 18.2259C26.6264 18.1526 26.519 18.0458 26.445 17.9167C26.3723 17.7899 26.334 17.6462 26.334 17.5C26.334 17.3538 26.3723 17.2102 26.445 17.0833L28.32 13.8358L29.7634 14.6692L28.61 16.6667Z"
                  fill="#B4C1D3"
                />
              </svg>
            </div>
          </template>
          <div class="chanel py-2" @scroll="handleScrollPage">
            <ul>
              <li class="my-3" v-for="item in listPage" :key="item.page_id">
                <input
                  type="checkbox"
                  v-model="selectedPage"
                  :value="item.page_id"
                  number
                  class="mr-2"
                  :id="item.page_id"
                />
                <label :for="item.page_id"
                  ><div class="title-label">
                    <v-avatar size="30" class="mx-1">
                      <v-img :src="item.avatar ? item.avatar : imgUser"></v-img>
                    </v-avatar>
                    {{ item.name }}
                  </div></label
                >
              </li>
            </ul>
          </div>
          <div class="chanel-btn py-4 pr-4">
            <v-btn @click="menuTwo = false" text>Hủy</v-btn>
            <v-btn
              @click="searchChanel(), menuTwo = false"
              color="#009FE0"
              text
              >Ok</v-btn
            >
          </div>
        </v-menu>
      </div>
    </v-navigation-drawer>

    <v-list two-line class="pl-15 ml-2 pt-0">
      <v-list-item-group>
        <div class="search-label pt-2 pb-2">
          <div class="px-2 w-full">
            <div class="d-flex align-center" style="column-gap: 10px;">
                <v-text-field
                        dense
                        solo
                        flat
                        placeholder="Tìm kiếm SĐT, Tên KH..."
                        class="custom-input-chat"
                        v-model="searchName"
                >
                </v-text-field>
                <div class="label-drawlerLeft">
                  <v-menu
                    offset-y
                    right
                    ref="menuOne"
                    v-model="menuOne"
                    :close-on-content-click="false"
                    :return-value.sync="selected"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        v-bind="attrs"
                        v-on="on"
                        style="height: 36px; border-radius: 4px; border: 1px solid #EBEAED;display: flex;align-items: center;padding: 5.5px"
                        class="custome-tag"
                        :class="{ activeFilter: selected && selected.length }"
                      >
                        <div class="d-flex align-center">
                            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.787193 -6.49516e-05H9.07843C9.26066 -6.49516e-05 9.39715 0.0442312 9.48863 0.17642L18.1444 8.55902C18.9641 9.30926 18.9641 10.5882 18.1444 11.3829L11.9491 17.3826C11.1294 18.1765 9.80795 18.1765 9.03327 17.3826L0.377547 9.00002C0.241052 8.91213 0.195312 8.77923 0.195312 8.60276V0.57314C0.195312 0.220178 0.468292 -0.000610352 0.787756 -0.000610352L0.787193 -6.49516e-05ZM11.4017 13.4121C11.2195 13.6329 10.8093 13.6329 10.6271 13.4121C10.3991 13.1913 10.3991 12.8383 10.6271 12.6183L13.2234 10.1038C13.4514 9.88305 13.8158 9.88305 14.0431 10.1038C14.2711 10.2803 14.2711 10.6776 14.0431 10.8541L11.401 13.4128L11.4017 13.4121ZM9.94385 12.0002C9.71587 12.221 9.35141 12.221 9.12415 12.0002C8.89617 11.7794 8.89617 11.4265 9.12415 11.2064L11.7662 8.64767C11.9942 8.42689 12.3587 8.42689 12.5859 8.64767C12.8139 8.86846 12.8139 9.22142 12.5859 9.44151L9.94385 12.0002ZM4.29524 3.97059C5.06992 3.22035 6.34551 3.22035 7.11945 3.97059C7.93915 4.72083 7.93915 5.95617 7.11945 6.70569C6.34477 7.49953 5.06918 7.49953 4.29524 6.70569C3.52056 5.95545 3.52056 4.72011 4.29524 3.97059ZM5.11494 4.76443C4.79622 5.07309 4.79622 5.60254 5.11494 5.91122C5.43366 6.26419 5.98036 6.26419 6.2991 5.91122C6.66356 5.60256 6.66356 5.07311 6.2991 4.76443C5.98038 4.45576 5.43368 4.45576 5.11494 4.76443ZM8.85045 1.10251H1.3339V8.38189L9.85244 16.6316C10.2169 16.9403 10.7636 16.9403 11.1281 16.6316L17.3691 10.5876C17.6878 10.2346 17.6878 9.70519 17.3691 9.35221L8.85045 1.10251Z" fill="#A5ADBB"/>
                            </svg>
                            <span style="color: #B0B7C3 !important;" class="pl-1">Nhãn</span>
                            <b v-if="selected && selected.length" class="select-tags mx-1">{{selected.length}}</b>
                            <v-icon color="#B0B7C3" style="color: #B0B7C3 !important;">mdi-chevron-down</v-icon>
                        </div>
                      </button>
                    </template>
                    <div class="list-labels">
                      <div class="mb-2 px-2 filter-content">Phân loại theo nhãn</div>
                      <div>
                        <ul>
                          <li>
                            <input
                              type="checkbox"
                              v-model="selectAll"
                              class="mr-2"
                              id="all"
                            />
                            <label for="all"
                              ><div class="title-label" style="color: black">
                                Tất cả phiếu
                              </div></label
                            >
                          </li>
                          <li v-for="item in labels" :key="item.label_id">
                            <input
                              type="checkbox"
                              v-model="selected"
                              :value="item.label_id"
                              number
                              class="mr-2"
                              :id="item.label_id"
                            />
                            <label :for="item.label_id">
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="tag-filter"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                   <v-icon :style="{ color: item.color }" class="mr-1">mdi-tag</v-icon> {{ item.label }}
                                  </div>
                                </template>
                                <span> {{ item.label }}</span>
                              </v-tooltip>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="list-label-btn">
                      <v-btn @click="menuOne = false" text>Hủy</v-btn>
                      <v-btn
                        @click="searchLabels(), $refs.menuOne.save(selected)"
                        color="#009FE0"
                        text
                        >Ok</v-btn
                      >
                    </div>
                  </v-menu>
                </div>
                <v-menu
                        offset-y
                        left
                        v-model="menuSearch"
                        :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn  v-bind="attrs"
                                v-on="on"  height="38" style="min-width:42px;width: 42px !important;" color="#1472AF" class="blue--text">
                            <v-icon color="#FFFFFF">mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <v-card class="mx-auto overflow-visible" width="300px" style="margin-top: 0px; margin-bottom: 0px;">
                        <v-list class="px-4 py-4">
                            <v-list-item-content>
                                <v-autocomplete
                                        multiple
                                        solo
                                        placeholder="Nhân viên sale"
                                        clearable
                                        :items="userSale"
                                        item-text="fullName"
                                        item-value="username"
                                        v-model="listQuery.sale"
                                        dense
                                        outlined
                                        flat
                                        append-icon="mdi-chevron-down"
                                        id="request"
                                        :menu-props="{ bottom: true, offsetY: true,  maxHeight: 150  }"
                                        no-data-text="Không có dữ liệu"
                                        attach>
                                </v-autocomplete>
                                <v-text-field
                                        type="number"
                                        clearable
                                        solo
                                        placeholder="Tìm theo số phản hồi của TP"
                                        v-model.number="listQuery.count_res_msg"
                                        dense
                                        outlined
                                        flat
                                        id="request"
                                        autocomplete="off"
                                        min="0"
                                        @input="handleInputNumber(listQuery.count_res_msg, $event)"
                                        @keydown="handleValidateDecimal"
                                />
                                <v-text-field
                                        clearable
                                        solo
                                        placeholder="Tìm theo ID hội thoại"
                                        v-model="listQuery.psid"
                                        dense
                                        outlined
                                        flat
                                        id="request"
                                        autocomplete="off"
                                />

                                  <div class="d-flex align-center" style="justify-content: center">
                                      <v-btn color="#FF8057" style="color: #fff" @click="searchLabels('advanced')">Tìm kiếm</v-btn>
                                  </div>
                            </v-list-item-content>
                        </v-list>
                    </v-card>

                </v-menu>
            </div>
              <div class="d-flex justify-space-between px-2 pt-2">
                  <div class="d-flex">
                      <div class="mr-3">
                          <div :class="{ activeNew: couter == 1 }" @click="getCovSearch(1, 'all')" >
                              <div class="item-read" style="cursor: pointer">Tất cả</div>
                          </div>
                      </div>
                      <div>
                          <div :class="{ activeNew: couter == 2 }" @click="getCovSearch(2, 'unread')">
                              <div class="item-read" style="cursor: pointer">Chưa đọc</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div id="drawler-left" @scroll="handleScroll">
          <!-- <div class="loading" v-if="users.length > 0">
            <v-progress-linear
              v-show="loading"
              indeterminate
              color="blue darken-2"
            ></v-progress-linear>
          </div> -->
          <template v-for="(item, index) in users">
            <v-list-item
              active-class="deep-purple--text text--accent-4"
              @click="pickUser(item)"
              :key="item.name"
              :class="
                item.unread_count !== constant.UNREAD_COUNT
                  ? 'notRead'
                  : 'readed' && idPick == item._id
                  ? 'activePick'
                  : 'noActivePick'
              "
            >
              <template>
                <v-list-item-avatar width="60" height="60">
                  <v-img
                    width="60"
                    :alt="`${item.name} avatar`"
                    :src="
                      item.customer.avatar_url
                        ? item.customer.avatar_url
                        : imgUser
                    "
                  ></v-img>
                </v-list-item-avatar>
                <v-badge
                  v-if="item.unread_count !== constant.UNREAD_COUNT"
                  color="red"
                  bordered
                  bottom
                  offset-x="32"
                  offset-y="-13"
                  :content="item.unread_count"
                >
                </v-badge>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="customer-name">
                      {{ item.customer.name }}
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img
                            :src="item.page.avatar"
                            v-bind="attrs"
                            v-on="on"
                            class="conv-page-avatar"
                          ></v-img>
                        </template>
                        <span>{{ item.page.name ? item.page.name : "" }}</span>
                      </v-tooltip>
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-icon
                      v-if="item.replied"
                      color="lighten-1"
                      class="replied-icon"
                      small
                      >mdi-reply</v-icon
                    >
                    <div class="customer-last_content">
                      {{ item.last_content }}
                    </div>
                  </v-list-item-subtitle>
                  <div class="labels">
                    <span
                      v-for="(label, index) in item.customer.labels"
                      :key="index"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            :style="{
                              background: label.color,
                              outline: `1px double ${label.color}`,
                            }"
                            class="label-item d-flex"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <span class="m-auto"> {{ label.label }}</span>
                          </div>
                        </template>
                        <span> {{ label.label }}</span>
                      </v-tooltip></span
                    >
                  </div>
                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text class="last-content">
                    {{ formatDate(item.ts) }}
                  </v-list-item-action-text>

                  <div class="icon">
                    <v-icon
                      v-if="
                        (item.customer.erp_phones &&
                          item.customer.erp_phones.length > 0) ||
                        (item.customer.phones &&
                          item.customer.phones.length > 0)
                      "
                      color="green lighten-1"
                      class="pl-1"
                      small
                    >
                      mdi-phone
                    </v-icon>
                    <v-icon
                      v-if="item.type == constant.COMMENT"
                      :color="item.unread_count == 0 ? '#676767' : '#F2994A'"
                      class="pl-1 icon-comment"
                      small
                    >
                      mdi-message-reply-text
                    </v-icon>
                    <v-icon
                      v-if="item.type == constant.MESSAGE"
                      :color="item.unread_count == 0 ? '#676767' : '#0081F3'"
                      class="pl-1 icon-phone"
                      small
                    >
                      mdi-facebook-messenger
                    </v-icon>
                  </div>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider v-if="index < users.length - 1" :key="index"></v-divider>
          </template>
        </div>
        <div id="notFound" v-if="users.length === 0">
          <h4>Không tìm thấy</h4>
        </div>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { pageService } from "../../repositories/PageService";
import { constant } from "../../helpers/constant";
import moment from "moment";
import eventBus from "../../plugins/eventBus";
export default {
  components: { DatePicker },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    phone: {
      type: String,
      default: () => null,
    },
    timer: {
      type: Number,
      default: 300,
    },
    userSale: {
        type: Array,
        default: () => [],
    },
  },
  name: "vh-navigation-drawler-left",
  data: () => ({
    idPick: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menuTwo: false,
    menuOne: false,
    drawer: true,
    imgUser: "https://cdn-cf.vuihoc.vn/default/default_avatar.jpg",
    selected: [],
    selectedPage: [],
    couter: 1,
    searchName: null,
    type: "all",
    constant,
    loading: false,
    timeOut: null,
    loadPage: 1,
    listPage: [],
    menuSearch: false,
    listSale: [],
      listQuery: {
          sale: [],
          psid: '',
          count_res_msg: '',
      }
  }),
  created() {
    eventBus.$on("loading", () => {
      this.loading = false;
    });
    this.getListPage();
  },

  watch: {
    searchName: {
      handler: function (val) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(async () => {
          val = val.trim();
          let params = {
            keyword: val,
          };
          if (this.selected.length > 0) {
            params.labels = this.selected;
            if (val === "") {
              delete params.keyword;
            }
          } else {
            if (val === "") {
              delete params.keyword;
              this.getCovSearch(this.couter, this.type);
            }
          }
          this.$emit("searchConv", params);
        }, this.timer);
      },
    },
  },
  methods: {
    handleValidateDecimal(e) {
      if (e.key === '.' || e.key === ',') {
        return  e.preventDefault();
      }
    },
    handleInputNumber(val) {
      if(val < 0) val = 0;
    },
    pickUser(user) {
      eventBus.$emit("pick-user", user);
      this.idPick = user._id;
    },
    formatDate(date) {
      const dateNow = new Date();
      const momentDate = moment(date).format("YYYYMMDD");
      const momentDateNow = moment(dateNow).format("YYYYMMDD");
      if (momentDateNow == momentDate) {
        return moment(date).format("HH:mm");
      } else {
        return moment(date).format("DD-MM-YYYY");
      }
    },
    handleScroll(event) {
      if (
        (event.target.offsetHeight + event.target.scrollTop).toFixed() >=
        event.target.scrollHeight - 1
      ) {
        this.loading = true;
        this.$emit("scrollEndCov");
      }
    },
    handleScrollPage(event) {
      if (
        (event.target.offsetHeight + event.target.scrollTop).toFixed() >=
        event.target.scrollHeight - 1
      ) {
        this.loadPage = this.loadPage + 1;
        this.getListPage();
      }
    },
    getCovSearch(couter, type) {
      this.loading = true;
      this.type = type;
      this.couter = couter;
      this.$emit("getCovSearch", type);
    },
    searchDate() {
      this.couter = 8;
      this.$emit("getCovSearch", "period_time", this.date);
    },
    searchChanel() {
      this.couter = 9;
      if (this.selectedPage.length > 0) {
        this.$emit("getCovSearch", this.selectedPage);
      } else this.$emit("getCovSearch", "all");
    },
    searchLabels(key) {
      let params = {
        labels: this.selected,
          ...this.listQuery
      };
      if (this.selected.length === 0) {
        delete params.labels;
      }
      if (this.searchName) {
        params.keyword = this.searchName;
      }
      if (this.listQuery.sale.length == 0) {
          delete params.sale;
      }
      if (this.listQuery.psid === '' || this.listQuery.psid == null) {
          delete params.psid;
      }
      if (this.listQuery.count_res_msg === '' || this.listQuery.count_res_msg == null) {
          delete params.count_res_msg;
      }
      if(key === 'advanced') {
          this.menuSearch = false
      }
      this.$emit("searchConv", params);
    },
    async getListPage() {
      let params = {
        page: this.loadPage,
      };
      const res = await pageService.getListPageAssigneds(params);
      this.listPage = this.listPage.concat(res.data);
    },
  },
  computed: {
    selectAll: {
      get: function () {
        return this.labels ? this.selected.length == this.labels.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.labels.map(function (user) {
            selected.push(user.label_id);
          });
        }
        this.selected = selected;
      },
    },
  },
  beforeDestroy() {
    eventBus.$off("loading");
  },
};
</script>
<style lang="scss" scoped>
.drawer-item {
  text-align: center;
  height: 68px;
  cursor: pointer;
  &.active {
    background: #36424e;
  }
  &:hover {
    transition: 0.25s;
    background: #36424e;
  }
  .item-image {
    align-items: center;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  span {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    text-align: center;
    color: #c2cfe0;
  }
}
.loading {
  position: absolute;
  top: 55px;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 0px 15px 0px 3px;
}

.icon {
  position: absolute;
  bottom: 13px;
}

.last-content {
  position: absolute;
  top: 17px;
}
.customer-name {
  max-width: 150px;
  /* overflow-x: auto; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6b778c;
  font-weight: 700;
  font-size: 14px;
}
.customer-last_content {
  font-size: 14px;
  color: #172b4d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.button-calender {
  position: absolute;
  bottom: 9px;
  right: 6px;
}
.labels {
  display: flex;
  flex-wrap: wrap;
  .label-item {
    margin: 2px;
    border-radius: 7px;
    font-size: 10px;
    color: white;
    padding: 2px;
    border: 2px solid #fff;
    height: 20px;
    max-width: 79px;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px;
    border-radius: 8px;
    font-weight: 700;
  }
}

.list-labels {
  background: #fff;
  z-index: 999;
  right: 3px;
  border: 1px solid #ebeaed;
  border-radius: 6px;
  box-shadow: 0px 1px 10px 0px #0000000d;
  padding: 10px 0px;
  top: 54px;
  overflow-y: auto;
  max-height: 300px;
  min-width: 200px;
  .filter-content {
    font-size: 14px;
    font-weight: 500;
    color: #6b778c;
    border-bottom: 1px solid #6b778c;
  }
  ul {
    list-style: none;
    padding: 0px 8px;
    li {
      display: flex;
      font-size: 11px;
      text-transform: uppercase;
      align-items: center;
      margin-bottom: 8px;
      .title-label {
        border: 1px solid #ebeaed;
        height: 21px;
        width: 95px;
        text-align: center;
        border-radius: 4px;
        padding-top: 3px;
        color: white;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.list-label-btn {
  background: #ffffff;
  text-align: center;
}
.v-list-item.v-list-item--link.theme--light.notRead {
  background: #eeede9;
  .icon-phone {
    color: #0081f3 !important;
  }
}
.v-list-item.v-list-item--link.theme--light.readed {
  background: #ffffff;
}
.notRead {
  .customer-name {
    color: black;
  }
  .customer-last_content {
    color: black;
  }
}
#notFound {
  position: absolute;
  height: 100vh;
  width: 100%;
  background: #f0f0f0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  h4 {
    color: grey;
  }
}
.replied-icon {
  float: left;
  padding-right: 5px;
}
.custome-tag {
  height: fit-content !important;
  justify-content: space-between;
  min-width: 90px !important;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  padding: 0 4px 0 8px;
  b {
    margin: auto;
  }
  span, i {
    color: black !important;
    margin: auto;
  }
  .select-tags {
    border-radius: 70%;
    background: #1768dd;
    color: #fff !important;
    padding: 0px 4px;
    font-size: 10px;
  }
  &:hover {
    background: #f1f1f1 !important;
    border-radius: 12px;
  }
  &:active,
  &:focus,
  &.activeFilter {
    border-radius: 12px;
    background: #e5efff !important;
    span {
      color: #1768dd !important;
    }
    i {
      color: #1768dd !important;
    }
  }
  &:active {
    border-radius: 12px;
    background: #e5efff !important;
    span {
      color: #1768dd !important;
    }
    i {
      color: #1768dd !important;
    }
  }
}
.item-read {
  color: #778aa4;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    color: #1768dd;
  }
}

.activeNew {
  .item-read {
    color: #1768dd !important;
  }
  border-bottom: 2px solid #1768dd;
}
.tag-filter {
  padding: 2px 8px;
  border-radius: 12px;
  &:hover {
    background: #f1f1f1;
  }
}
</style>
<style lang="scss">
.custom-input-chat {
  .v-input__slot {
    background: #fff !important;
    border: 1px solid #EBEAED !important;
    margin-bottom: 0 !important;
    &:hover {
      //border: 1px solid #1768dd !important;
      background: #fff !important;
      transition: 0.5s;
    }
  }
}
.search-label {
  position: fixed;
  width: 82%;
  z-index: 999;
  margin-left: 2px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  box-shadow: 0px 1px 10px 0px #0000000d;
  .v-text-field__details {
    display: none !important;
  }
  label.v-label.theme--light {
    color: #a5adbb;
  }
}

.label-drawlerLeft {
  span > span {
    text-transform: none;
    font-size: 14px;
    color: #a5adbb;
    font-weight: 400;
  }
}
.activePick {
  background: #e5efff !important;
  .icon-phone {
    color: #0081f3 !important;
  }
  .icon-comment {
    color: #f2994a !important;
  }
}
.noActivePick {
  &:hover {
    background: #f1f1f1 !important;
  }
}
div#drawler-left {
  padding-top: 84px;
  overflow-y: auto;
  max-height: calc(100vh - 73px);
}

#drawer-chat-left {
  .v-navigation-drawer__content {
    height: 100%;
    overflow-y: hidden !important;
    overflow-x: hidden !important;
  }
  #drawer-chat-search {
    .v-navigation-drawer__content {
      height: 100%;
      overflow-y: auto !important;
      overflow-x: hidden !important;
    }
  }
}
.chanel {
  overflow-y: auto;
  max-height: 300px;
  width: 300px;
  background: white;
  ul {
    list-style: none;
    li {
      display: flex;
      align-items: center;
    }
  }
}
.chanel-btn {
  text-align: right;
  background: white;
}
.conv-page-avatar {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}
</style>
